export const productLabelMap = {
  'Circuit Boards': 'cbItemNumbers',
  'Printer Circuit Boards': 'cbItemNumbers',
  Readers: 'readerItemNumbers',
  'Power Supplies': 'powerSupplyItemNumbers',
  'Bill Acceptors': 'billAcceptorNumberItems',
  'MINI/Quad Bursters': 'quadBursterNumberItems',
  Terminal: 'terminals',
  Printers: 'printers',
  'Comm Device': 'commDevice',
  'Display/Monitors': 'displayMonitor',
  Peripherals: 'peripherals',
};

export const billAcceptorNumberItems = [
  '15-2514-01',
  '15-3979-01E (PROJECT)',
  '17-0960-01E',
  '17-1222-01E',
  '24-1909-08E',
  '50-0270-02',
  '50-0295-01',
  '50-0296-01',
  '50-0296-01E',
  '50-0296-02E',
  '50-0305-01',
  '50-0305-01E',
  '50-0305-02E',
  '50-0305-04E',
  '50-0305-05E',
  '50-0313-01E',
  '50-0313-02E',
  '50-0340-01E',
  '50-0354-01E (PROJECT)',
  '50-0361-01E',
  '50-122-0062-01',
  '50-122-0062-02',
  '50-122-0068-01',
  '50-122-0070-01',
  '50-122-0070-02',
  '50-122-0071-02',
  '50-122-0092-30',
];

export const cbItemNumbers = [
  '030-599-0032-05 (PROJECT)',
  '1502074-01 (PROJECT)',
  '15-3321-01',
  '15-3535-01E',
  '15-3717-21E',
  '15-3723-01E',
  '15-3945-01E',
  '15-4123-01E (PROJECT)',
  '15-4501-02E',
  '20-0294-01',
  '20-0332-01',
  '20-1286-01E',
  '20-1287-01E',
  '20-1289-01E (POWER BUTTON)',
  '20-1289-01E (POWER BUTTON)',
  '22-1866-01E',
  '2-12367',
  '24-120-0011-01',
  '24-120-0091-53',
  '24-1607-01',
  '24-1607-02',
  '24-1644-01E',
  '24-1644-02E',
  '24-1788-01E',
  '24-1909-08E (PROJECT)',
  '24-1919-05E',
  '24-1925-01E',
  '24-1939-05E',
  '2-43832',
  '2-43940',
  '2-43940 (PROJECT)',
  '2-44033 (PROJECT)',
  '2-44034 (PROJECT)',
  '2-44065',
  '32-171-0703-01E',
  '43-1728-02E (MEMORY 1GB)',
  '444-1000',
  '444-1000 DELL CFD',
  '444-1001',
  '45-0078-02',
  '45-0136-01',
  '45-0162-01',
  '45-0162-01E',
  '45-0162-02E',
  '45-0176-01E',
  '45-0189-02E (PROJECT)',
  '45-0194-01E (LCD PANEL)',
  '45-0209-01E (PROJECT)',
  '45-0210-01E (PROJECT)',
  '46-1296-01E (PROJECT)',
  '46-1858-02E (COMPACT FLASH 2GB)',
  '50-0203-01',
  '50-0232-01',
  '50-0243-02 (POWER SUPPLY)',
  '50-0245-01',
  '50-0245-02E',
  '50-0245-03',
  '50-0340-01E (PROJECT)',
  '50-0360-01E',
  '50-0379-01E (PROJECT)',
  '50-172-0011-01',
  '50-172-0011-01E',
  '50-172-0022-01',
  '50-172-0022-01E',
  '51-0681-01',
  '51-0756-01',
  '51-0759-01',
  '51-0761-01',
  '51-0764-01',
  '51-0764-02E',
  '51-0784-01',
  '51-0829-01',
  '51-0928-01',
  '51-0944-01',
  '51-0944-01E',
  '51-0989-01',
  '51-0989-01E',
  '51-0989-03E',
  '51-0997-01',
  '51-1000-01',
  '51-1000-01E',
  '51-1002-02',
  '51-1002-03',
  '51-1002-05',
  '51-1002-06',
  '51-1028-01',
  '51-1028-01E',
  '51-1037-01E (PROJECT)',
  '51-1045-01',
  '51-1049-01E',
  '51-1581-01',
  '51-1623-01',
  '51-1623-01E',
  '51-1623-02E',
  '51-1623-02E (PROJECT)',
  '51-1623-04E',
  '51-1625-01',
  '51-1625-01E',
  '51-1625-04E',
  '51-1626-01E',
  '51-1630-02',
  '51-1632-01',
  '51-1632-01E',
  '51-1653-01',
  '51-1653-01E',
  '51-1654-01',
  '51-1661-01E',
  '51-1664-01',
  '51-1664-01E',
  '51-1665-02E',
  '51-1666-01',
  '51-1666-01E',
  '51-1666-02',
  '51-1666-05',
  '51-1676-01E',
  '51-1676-02E',
  '51-1676-03E',
  '51-1676-04E',
  '51-1676-05E',
  '51-1676-06E',
  '51-1685-01E',
  '51-1686-01E',
  '51-1688-01',
  '51-1688-01E',
  '51-1689-01E',
  '51-1691-01E',
  '51-1693-01E',
  '51-1693-02E',
  '51-1693-04E',
  '51-1693-05E',
  '51-1698-02E',
  '51-1702-01',
  '51-1764-01E',
  '51-1764-02E',
  '51-1764-06E',
  '51-1780-01E',
  '51-1781-01E',
  '51-1782-01E',
  '51-1782-02E',
  '51-1783-01E',
  '51-1784-01E',
  '51-1784-03E',
  '51-1785-01E',
  '51-1786-01E',
  '51-1787-01E',
  '51-1789-01E',
  '51-1790-01E',
  '51-1794-01E',
  '51-1795-01E',
  '51-1800-01E',
  '51-1800-02E',
  '51-180-0060-45',
  '51-180-0066-01',
  '51-180-0066-02',
  '51-180-0069-12',
  '51-180-0073-12',
  '51-180-0073-22',
  '51-180-0121-01',
  '51-180-0121-01E',
  '51-1806-01E',
  '51-1807-01E',
  '51-1816-01E',
  '51-1818-01E (PROJECT)',
  '51-1821-01E (PROJECT)',
  '51-1821-02E (PROJECT)',
  '51-1821-03E (PROJECT)',
  '51-1865-01E',
  '51-1866-01E',
  '51-1867-01E',
  '51-1868-01E',
  '51-1869-01E',
  '51-1871-01E',
  '51-1876-01E',
  '51-1877-01E',
  '51-1883-01E',
  '51-1891-01E',
  '51-1891-03E',
  '51-1899-01E',
  '51-1899-01E (PROJECT)',
  '51-1899-06E',
  '51-1899-06E (PROJECT)',
  '51-1909-01E',
  '51-1909-01E (PROJECT)',
  '51-1911-01E',
  '51-1911-03E (PROJECT)',
  '51-1911-04E',
  '51-1923-01E',
  '51-1924-03E (PROJECT)',
  '51-1930-01E',
  '51-1934-03E (PROJECT)',
  '51-1940-01E (PROJECT)',
  '51-1941-01E',
  '51-1942-01E',
  '51-1958-01E',
  '51-1958-02E',
  '51-1984-01E (PROJECT)',
  '51-1991-01E',
  '51-9060-14',
  '51-9060-65',
  '51-9062-01',
  '51-9064-10',
  '51-9106-01',
  '51-9110-01',
  '51-9113-01',
  '51-9113-02',
  '51-9113-03',
  '51-9113-04',
  '51-9113-04E',
  '51-9113-20',
  '51-9120-01',
  '52-0660-01E',
  '52-0662-01E',
  '52-125-0001-01E',
  '53-0131-01',
  '53-0131-01E',
  '53-0131-02E',
  '53-0669-01E',
  '53-0697-01E (PROJECT)',
  '53-123-0002-01',
  '53-123-0003-01E',
  '53-124-0015-01',
  '53-124-0015-51',
  '53-124-0020-01',
  '53-124-0020-01E',
  '53-1824-02E',
  '53-1824-06E',
  '599-0032-05',
  '599-0032-05 (PROJECT)',
  '599-0032-06',
  '599-0032-06 (PROJECT)',
  '599-0042-02',
  '599-0042-02 (PROJECT)',
  '599-0091-00',
  '61-0784-05E',
  '61-0901-34E',
  '61-2000-16E (PROJECT)',
  '71-1434-01E',
  '740-0000-AA (PROJECT)',
  '74-1374-01E',
  '764-0000-AA1 (PROJECT)',
  '765-0000-AA1 (PROJECT)',
  'DELL 1708FPB',
  'DELL 1708FPF',
  'DELL 1708FPT',
  'DELL 196FPB',
  'DELL P1913SF',
  'DELL E176FPF',
  'DELL E178FPC',
  'DELL E1910F (PROJECT)',
  'DELL E197FPF',
  'DELL E2210C',
  'DELL E2210F (PROJECT)',
  'DELL E2214HB (PROJECT)',
  'DELL P170SB',
  'DELL P170SF',
  'DELL P170ST',
  'DELL P1914SF',
  'DS2278 (PROJECT)',
  'DS6878 (PROJECT)',
  'DELL P2217H (PROJECT)',
  'E00136',
  'LT-160721UB',
  'RI-74-1483-01',
];

export const commDevice = ['Ventus', 'Hughes'];

export const displayMonitor = [
  '15-4102-02E',
  '15-4105-02E',
  '15-4105-03E',
  '15-4492-01',
  '50-0360-01E',
  '50-0360-02E',
  '50-0379-01E',
  '53-0671-01E',
  'ESMM',
  'NY-444-2004',
  'TV',
];

export const fstLotteryProducts = [
  'Bill Acceptors',
  'Circuit Boards',
  'Comm Device',
  'Display/Monitors',
  'MINI/Quad Bursters',
  'Peripherals',
  'Power Supplies',
  'Printers',
  'Readers',
  'Terminal',
];

export const lotteryFailureModes = [
  'Adjust Color',
  'Bad Backlight',
  'Bad Cable',
  'Bad Components',
  'Bad Cut',
  'Bad Image',
  'Bad Key',
  'Bad LEDs',
  'Bad Motor',
  'Bad PCB',
  'Bad Print',
  'Bad Video',
  'Battery',
  'Bin Failure',
  'Broken Chassis',
  'Broken Glass',
  'Clear Throat',
  'Cold Solder',
  'Comm Port Failure',
  'Conversion',
  'Cycling',
  'Damaged Parts',
  'Disk Error',
  'Failed Touchscreen',
  'Incorrect Firmware',
  'Jamming',
  'Loose Components',
  'Missing Components',
  'Missing Parts',
  'Motor Runs Constantly',
  'No Burster',
  'No DIAGS',
  'No Display',
  'No Key Response',
  'No Power',
  'No Response',
  'No Security ID',
  'No Standalone',
  'No Video (Burnt PCB Or Components)',
  'No Video (Damaged Traces Or Components)',
  'No Video (Install Printer Library)',
  'No Video (Liquid Damaged)',
  'No Video (Locks Up During Test)',
  'No Video (New U33 Installed From MFG.)',
  'No Video (No Audio From LCD)',
  'No Video (No External Video)',
  'No Video (No Touchscreen Responses)',
  'No Video (Ping Test)',
  'No Video (Scanning Terminal)',
  'No Video (USB And Or Ethernet Port Damaged)',
  'Noise Motor',
  'Not Accepting Playslips',
  'Not inatializing',
  'Offline',
  'Paper Sensor',
  'Printer Port Failure',
  'Reader Error',
  'Reject Bills',
  'Rejecting Ticket',
  'Removal',
  'Resetting',
  'Scratched',
  'Shorted components',
  'Shorted PCB',
  'Stacker Damage',
  'TPI Failure',
  'Unknown Fault',
  'Unloading Ticket',
  'Water damage',
  'Wont Boot',
  'Wont Calibrate',
  'Wont Dispense Ticket',
  'Wont Load Ticket',
  'Wont Scan',
  'Wont Show in Diagnostic',
  'Wont Take Bills',
];

export const oemVendors = [
  'None',
  'Auo',
  'BCM Advanced Research',
  'Carmanah Signs',
  'Custom',
  'Dell',
  'Elo',
  'Ennoconn',
  'IEI Integration Corp.',
  'Intelligent Data',
  'JCM',
  'Kortek',
  'Lenovo',
  'MEI Bill Acceptor',
  'System Level Solutions India Pvt. Ltd.',
  'Transact',
  'Verifone',
  'Wellsgardner',
  'Zebra Technologies',
];

export const partsBenchRepair = [
  'None',
  '003704-1.5 (E-RING SUS)',
  '070720 (STACKER SPRING)',
  '10-0105E (SCR MACH 4-40X.38 PNH PH)',
  '10-0757-01E (STDF 4-40X.18LG .19HEX MF STL)',
  '10-1058-01 (E-RING .156)',
  '10-1263-01E (C CLIP E-TYPE)',
  '10-1366-01 (SCR #6-20X3/8 THREAD CUTTING PNH PH)',
  '10-1368-01 (NUT M3)',
  '10-1369-01 (SPADE)',
  '10-1370-01 (E-RING .170 I.D.)',
  '10-1371-01 (E-RING STACKER ASSY ACCTHRM SUPREME)',
  '10-1372-01 (CLIP WIRE HARNESS ACCTHRM SUPREME)',
  '10-1373-01 (SCR #4 PLASTIC THREAD FORMING)',
  '10-1374-01 (SCR M3X6 PNH PH)',
  '10-1376-01 (SCR #4 PLASTIC THREAD FORMING SHORT)',
  '10-1436-01E (SCSI CONNECTOR M 2.6 HEX/SLOT STANDOFF)',
  '10-2045-01E (SCR MACH M3 X 4MM FLH PH W/NYLOK GT1200)',
  '10-2147-01E (RETAINER E-RING .125)',
  '10-2311-01E (SCR M3 X 8MM LONG LOW HEAD HEXALOBULAR)',
  '10-2334-01E (TAPE VHB DOUBLE SIDE LONG FLEX T-1500)',
  '11-310-0006-01E (CAM FLAT .625X.937X.125)',
  '11-3173-01 (BRACKET TOF SENSOR ACCTHRM SUPREME)',
  '11-3174-01 (FRAME-KNIFE ACCTHRM SUPREME)',
  '11-3178-01 (FRAME MAIN ACCTHRM SUPREME)',
  '11-3446-01E (ENCLOSURE CABLE RETENTION ITVM)',
  '11-3494-01E (GROUNDING TAB)',
  '11-3583-01E (PCI SHIELD BLANK GT1100)',
  '11-3583-01E (PCI SHIELD BLANK GT1100)',
  '11-3618-01 (GROUND ESD PLATEN & KNIFE ACC SUP)',
  '11-3786-01E (FRAME TERMINAL CHASSIS GT1200)',
  '11-3787-01E (BRACKET READER SUPPORT GT1200)',
  '11-3788-01E (BRACKET SCSI CABLE GT1200)',
  '11-3799-01E (FILLER PLATE RIGHT SIDE PANEL GT1200)',
  '11-3800-01E (FILLER PLATE LEFT SIDE PANEL GT1200)',
  '11-3802-01E (BRACKET PCI SLOT GT1200)',
  '11-3802-01E (BRACKET PCI SLOT GT1200)',
  '11-3804-01E (BRACKET LCD FRAME GT1200)',
  '11-3805-01E (COVER PCB READER GT1200)',
  '11-3807-01E (ASSY WELDMENT COVER CPU CHASSIS GT1200)',
  '11-3808-01E (BRACKET CABLE MOUNT GT1200)',
  '11-3812-01E (COVER PLATE CIS SPRING GT1200)',
  '11-3814-01E (BRACKET TRANSPORT HYBRID MOTOR GT1200)',
  '11-3815-01E (BRACKET SIDE FRAME RIGHT 8.5 RDR GT1200)',
  '11-3816-01E (BRACKET SIDE FRAME LEFT 8.5 RDR GT1200)',
  '11-3840-01E (FRAME BOTTOM READER GT1200)',
  '11-3851-01E (BRACKET IDLER ROLLER NO TPH)',
  '11-3874-01E (COVER TOP PLUNGER QUAD BURSTER)',
  '11-3890-01E (PANEL BOTTOM QB BOX LVM)',
  '11-3891-01E (PANEL TOP QB BOX LVM)',
  '11-3892-01E (PANEL LEFT SIDE QB BOX LVM)',
  '11-3893-01E (PANEL RIGHT SIDE QB BOX LVM)',
  '11-3894-01E (SIDE BAR LEFT CHUTE DOOR LVM)',
  '11-3895-01E (SIDE BAR RIGHT CHUTE DOOR LVM)',
  '11-3898-01E (FLAP DRAWER TOP LVM)',
  '11-3899-01E (HINGE DOOR DRAWER FLAP LVM)',
  '11-3900-01E (HINGE DOOR TICKET CHUTE LVM)',
  '11-3901-01E (BRACKET UPPER INTERLOCK LVM)',
  '11-3902-01E (BRACKET LOWER INTERLOCK LVM)',
  '11-3903-01E (DOOR FRONT QB ENCLOSURE LVM)',
  '11-3904-01E (BRACKET DOOR LOCK LVM)',
  '11-3906-01E (SPRING TAB QB DRAWER LVM)',
  '11-3942-01E (CABINET SIDE PANEL RIGHT LVM)',
  '11-3943-01E (CABINET LATCHBAR LVM)',
  '11-3946-01E (DOOR LATCH BAR BRACKET LVM)',
  '11-3951-01E (BRACKET ANGLE INTERLOCK LVM)',
  '11-3957-01E (CABINET FOOT LEFT FRONT LVM)',
  '11-3959-01E (MAIN DOOR HINGE LVM)',
  '11-3960-01E (MAIN DOOR PANEL LVM)',
  '11-3961-01E (MAIN DOOR UPPER CORNER BRACE LVM)',
  '11-3962-01E (MAIN DOOR LOWER CORNER BRACE LVM)',
  '11-3963-01E (MAIN DOOR BEAM LOWER HORIZ LVM)',
  '11-3964-01E (MAIN DOOR BEAM VERT MID LVM)',
  '11-3965-01E (MAIN DOOR BEAM HORIZ MID LVM)',
  '11-3966-01E (MAIN DOOR BEAM VERTICAL RIGHT LVM)',
  '11-3967-01E (MAIN DOOR BEAM OVAL TOP LVM)',
  '11-3968-01E (MAIN DOOR BEAM PERIPHERAL TOP LVM)',
  '11-3972-01E (DRAWER BURSTER LVM)',
  '11-3973-01E (BRACKET DRAWER SLIDE RIGHT LVM)',
  '11-3974-01E (BRACKET DRAWER SLIDE LEFT LVM)',
  '11-3975-01E (CROSS BAR DRAWER LVM)',
  '11-3976-01E (CLIP CABLE BURSTER DRAWER LVM)',
  '11-3977-01E (MAIN DOOR HINGE SIDE CLAMP BEAM LVM)',
  '11-3978-01E (FRONT PANEL INSTANT TICKET INSERT LVM)',
  '11-3979-01E (RIGHT SIDE SPRT INSTANT TKT INSERT LVM)',
  '11-3980-01E (LEFT SIDE SPRT INSTANT TKT INSERT LVM)',
  '11-3981-01E (BRKT CROSS BRACE STIFFENER)',
  '11-3982-01E (BRKT CROSS BRACE STIFFENER TOP)',
  '11-3984-01E (BRKT CROSS BRACE DEFLECTOR)',
  '11-3985-01E (TOUCHSCREEN MOUNTING PLATE LVM)',
  '11-3987-01E (CHASSIS CONTROLLER LVM)',
  '11-3991-01E (ENCLOSURE PCB CONTROLLER LVM)',
  '11-3992-01E (DOOR ENCLOSURE ELECTRONICS LVM)',
  '11-3993-01E (BRACKET DOOR OPEN SENSOR DOOR LVM)',
  '11-3995-01E (SHELF POWER SUPPLY LVM)',
  '11-3997-01E (FRONT PLATE QUICK PICK 6 LVM)',
  '11-4000-01E (SLIDE BRACKET QUICK PICK LVM)',
  '11-4001-01E (BACK COVER QUICK PICK 6 LVM)',
  '11-4004-01E (HINGE BAR QUICK PICK LVM)',
  '11-4005-01E (BUTTON SUPPORT UPPER QUICK PICK 6 LVM)',
  '11-4008-01E (SLIDE BAR QUICK PICK LVM)',
  '11-4009-01E (PANEL TOP ENCLOSURE LVM)',
  '11-4012-01E (BRKT LOWER LCD WINDOW CLAMP LVM)',
  '11-4017-01E (FRONT DOOR DBV/MEI LVM)',
  '11-4018-01E (BRACKET MOUNTING DBV LVM)',
  '11-4019-01E (BRACKET MOUNTING BOTTOM DBV LVM)',
  '11-4020-01E (BRACKET SENSOR DOOR DBV/UBA LVM)',
  '11-4021-01E (BRACKET SENSOR  DBV LVM)',
  '11-4022-01E (DOOR STAY DBV LVM)',
  '11-4024-01E (COVER UPPER INTERLOCK LVM)',
  '11-4025-01E (BRACKET HANDLE DRAWER LVM)',
  '11-4026-01E (PLATE SIDE LOCK BURSTER LVM)',
  '11-4027-01E (BRACKET ANGLE CHUTE DOOR LVM)',
  '11-4032-01E (TICKET BUCKET LEFT SIDE LVM)',
  '11-4038-01E (SHELF LOCK BOX LVM)',
  '11-4039-01E (DOOR LOCK BOX LVM)',
  '11-4040-01E (LATCH PLATE LOCK BOX LVM)',
  '11-4041-01E (PAN BASE CABINET LVM)',
  '11-4042-01E (BRACE DOOR LVM)',
  '11-4065-01E (BRACKET DRAWER STOPPER GT1200)',
  '11-4069-01E (BUTTON SUPPORT LOWER QUICK PICK 6 LVM)',
  '11-4080-01E (CORNER BRACKET FIXED PANEL LEFT LVM)',
  '11-4081-01E (CORNER BRACKET FIXED PANEL RIGHT LVM)',
  '11-4082-01E (CROSS BRACE ELECTRONICS ENCL LVM)',
  '11-4083-01E (DOOR BRACKET ELECTRONICS ENCL LVM)',
  '11-4095-01E (BRACKET POWER SWITCH AND SPEAKER LVM)',
  '11-4096-01E (COVER POWER SWITCH AND SPEAKER LVM)',
  '11-4100-352E (MOUNT TOP ENCL LVM BLACK BK001 SMOOTH)',
  '11-4104-01E (COVER REAR PANEL & TOROID LVM)',
  '11-4118-01E (FIXED RAMP LOWER LVM)',
  '11-4120-01E (RIGHT SIDE PANEL BET SLIP HOLDER LVM)',
  '11-4121-01E (FRONT PANEL BET SLIP HOLDER LVM)',
  '11-4122-01E (REAR PANEL BET SLIP HOLDER LVM)',
  '11-4140-01E (BRKT DOOR STAY STOP LVM)',
  '11-4142-01E (BRKT DOOR STAY CABINET HOLD DOWN LVM)',
  '11-4148-01E (REAR PANEL LONG BET SLIP HOLDER LVM)',
  '11-4149-01E (BRKT PEN HOLDER BET SLIP HOLDER LVM)',
  '11-4156-302E (COVER PANEL DBV B/A MASK LVM BLACK)',
  '11-4157-01E (BRACKET QUICK PICK DOOR SWITCH LVM)',
  '11-4159-01E (BRKT TOP ENCLOSURE PANEL LEFT LVM)',
  '11-4160-01E (BRKT TOP ENCLOSURE PANEL RIGHT LVM)',
  '11-4161-01E (FILLER PLATE UPPER HINGE LVM DOOR)',
  '11-4162-01E (FILLER PLATE LOWER HINGE LVM DOOR)',
  '11-4194-01E (BRACKET GT1200 RESET SWITCH LVM)',
  '11-4195-01E (HINGE STORAGE BOX LVM)',
  '11-4227-01E (FIXED RAMP FLANGE RIGHT LVM)',
  '11-4230-01E (PANEL REAR CONNECTOR AC INPUT LVM)',
  '11-4231-01E (REAR PANEL FILLER LVM)',
  '11-4232-01E (BRKT MOUNTNG BRSTER DRAWR SPRING TAB LVM)',
  '11-4240-01E (TICKET BUCKET RIGHT SIDE LVM -ULTRA PTR)',
  '11-4243-01E (BRKT DOOR OPEN SENSOR CABINET SIDE LVM)',
  '11-4244-01E (BRKT ROLLER DOOR RAMP LVM)',
  '11-4245-01E (BRKT DOOR RAMP LVM)',
  '11-4246-01E (PLATE LAMINATE DOOR RAMP LVM)',
  '11-4247-01E (TICKET BUCKET LVM - ULTRA PTR)',
  '11-4251-01E (PRINTER MOUNT UPPER LVM)',
  '11-4252-01E (PRINTER MOUNT LOWER LVM)',
  '11-4253-30E (PERIPHERAL PANEL DBV ADA 2D GEMINI BLACK)',
  '11-4254-01E (BACKER PLAYER INPUT BOARD)',
  '11-4255-01E (BRACKET IMAGER SCANNER LVM)',
  '11-4257-01E (BACKING PLATE CORD REEL LVM)',
  '11-4258-01E (BRACKET BURSTER CABLE W/DB9)',
  '11-4260-01E (TOUCHSCREEN MTG FRONT PLATE LVM)',
  '11-4320-01E (BRKT ULTRA PRINTER PROTECTION LVM)',
  '11-4347-01E (BRKT DATA CABLE MANAGEMENT LVM ULTRA PTR)',
  '11-4348-01E (PLATE SPACER RIGHT VERTICAL RAIL LVM)',
  '11-4350-01E (CABLE GUIDE BASE LVM)',
  '11-4351-01E (CABLE GUIDE RIGHT LVM)',
  '11-4352-01E (CABLE GUIDE LEFT LVM)',
  '11-4353-01E (CABLE GUIDE TOP LVM)',
  '11-4356-01E (BACKING PLATE CABLE GUIDE LVM)',
  '11-4357-01E (READER CABLE MOUNTING PLATE LVM)',
  '11-4493-01E (BACKPLATE TICKETSCAN PLUS)',
  '11-4494-01E (HOOK BRACKET TICKETSCAN PLUS)',
  '11-4500-01E (BRKT ALARM DISABLE SWITCH LVM-2)',
  '11-4538-01E (BRKT PRINTER SLIDE RETENTION LVM)',
  '11-4539-01E (COVER READER TRAY UP GT1200)',
  '11-4549-01E (LEFT SIDE PNL BETSLIP HOLDER 48" GEMINI)',
  '11-4550-01E (HAT BETSLIP HOLDER 48" GEMINI)',
  '11-4551-01E (Z BRACKET BETSLIP HOLDER 48" GEMINI)',
  '11-4590-01E (SIDE WALL RIGHT ADA BUCKET LVM)',
  '11-4591-01E (SIDE WALL LEFT ADA BUCKET LVM)',
  '11-4597-01E (STOP BRKT ADA BUCKET LVM)',
  '11-4600-01E (BRACKET ARC RACK ADA BUCKET LVM)',
  '11-4600-02E (BRACKET SLOTTD ARC RACK ADA TKT BUCK LVM)',
  '11-4601-01E (CROSS BRACE ARC RACK ADA BUCKET LVM)',
  '11-4603-01E (BRACKET MTG ADA BRG BUCKET LVM)',
  '11-4604-01E (BRACKET MTG SPRING ADA BUCKET LVM)',
  '11-4606-01E (BRKT PUSH PRINTER ADA BUCKET LVM)',
  '11-4607-01E (BRACE REAR RIGHT ADA BUCKET LVM)',
  '11-4608-01E (BRKT MTG SPRING STOP ADA BUCKET LVM)',
  '11-4610-01E (BRACKET LED BOARD ADA BCKET ILLUMINATION)',
  '11-4611-01E (MOUNTING BRACKET KEYPAD PCB)',
  '11-4614-01E (BEZEL ADA KEYPAD)',
  '11-4621-01E (LOWER CLAMP ADA TICKET BUCKET LVM)',
  '11-4622-01E (PLATE STOP GUIDE ADA TICKET BUCKET LVM)',
  '11-4623-01E (TAB SPRING ADA TICKET BUCKET LVM)',
  '11-4630-01E (SPACER POST CLAMP ADA TICKET BUCKET LVM)',
  '11-4637-01E (DOOR CAM 3 INCH TICKET CHUTE)',
  '11-4641-01E (BRKT BUCKET ILLUM 3 INCH TKT CHUTE)',
  '11-4642-01E (WATERFALL DOOR STIFFENER, TOP)',
  '11-4643-01E (WATERFALL DOOR STIFFENER)',
  '11-4644-01E (FLAP DRAWER FRONT W/STIFFENER)',
  '11-4645-01E (FLAP DRAWER BOTTOM W/STIFFENER)',
  '11-4646-01E (FRAME LCD 15" GT1200)',
  '11-4647-01E (COVER PCB LCD 15" GT1200)',
  '11-4651-01E (BRACKET STRETCH ADA TICKET BUCKET LVM)',
  '11-4660-01E (BRKT BILL SAFE DOOR STAY RETENTION)',
  '11-4672-01E (BRKT DOOR STAY HOLD DOWN PIVOT)',
  '11-4673-01E (DOOR STAY GEMINI WITH STOPS)',
  '11-4674-01E (BRKT DOOR STOP PIVOT)',
  '11-4675-01E (BRKT DOOR STOP CASTER)',
  '11-4676-01E (DRAWER FRONT W/FAN CUTOUT GT1200)',
  '11-4710-01E (BRKT DEAD BOLT MAIN DOOR LVM-3)',
  '11-4716-01E (BRKT LWR CABLE CLAMP DRAWER LVM-3)',
  '11-4721-01E (MOUNT RIGHT TICKET BUCKET LVM-3)',
  '11-4722-01E (MOUNT LEFT TICKET BUCKET LVM-3)',
  '11-4725-01E (BRKT HANDLE LATCH LVM-3)',
  '11-4728-01E (COVER BRKT LATCH ROLLER LVM-3)',
  '11-4737-01E (BRACKET SPRING LATCH BAR LVM-3)',
  '11-4792-01E (CABINET MAIN DOOR SENSOR BRACKET LVM-3)',
  '11-4805-01E (BRKT DOOR STAY CABINET HOLD DOWN LVM-3)',
  '11-4806-01E (DOOR STAY WITH STOPS LVM-3)',
  '11-4807-01E (BRKT DOOR STAY DOOR MOUNT LVM-3)',
  '11-4827-01E (BRACKET SIDE DOOR SWITCH GEMINI TOUCH)',
  '11-4831-01E (AGE CONTROL MOUNTING STRAP GEM-T)',
  '11-4832-01E (CAB FOOT LVM-3 28)',
  '11-4841-01E (CAB BOTTOM SIDE COVER PLATE LVM-3 28)',
  '11-4872-01E (ARM ROCKER WATERFALL LVM-3)',
  '11-4873-01E (BASE ROCKER ARM WATERFALL LVM-3)',
  '11-4874-01E (TAB ROCKER ARM WATERFALL LVM-3)',
  '11-4893-01E (BATTERY HOLDER LVM-3 28)',
  '11-4894-01E (BATTERY HANDLE LVM-3 28)',
  '11-4903-01E (BRACKET LATCH KICKER GEMINI ULTRA)',
  '11-4904-01E (CPU DRAWER ATOM E3800 GT1200)',
  '11-4905-01E (BRKT LATCH RESTRICTOR FLOATING PLATE LVM)',
  '11-4906-01E (DOOR LATCH MOUNTING BRKT LVM)',
  '11-4907-01E (DOOR LATCH BUSHING BRACKET LVM)',
  '11-4926-01E (BRKT TICKET DEFLECTOR ADA BUCKET)',
  '11-4961-01E (ENCLOSURE LCD MTG NLT DISPLAY GEMINI)',
  '11-4962-01E (BRKT LCD MTG NLT DISPLAY GEMINI)',
  '11-5002-01E (MAIN POWER SWITCH HOUSING LVM-3 28)',
  '11-5003-01E (MAIN POWER SWITCH COVER LVM-3 28)',
  '11-5007-01E (TOUCHSCREEN PCB MOUNTING PLATE GEMT 28)',
  '11-5051-01E (FLANGE CAP BURSTER DRAWER LVM-3)',
  '11-5070-01E (CLAMP VERIFONE DONGLE LVM-3)',
  '11-5116-01E (LWR MTG BRKT 32 INCH DISP)',
  '11-5117-01E (MTG BRACE VESA 32 INCH DISP)',
  '11-5118-01E (COLUMN SUPPORT DOOR)',
  '11-5119-01E (PANEL MAIN DOOR)',
  '11-5120-01E (CROSS BRACE LWR DOOR)',
  '11-5121-01E (MID CROSS BRACE DOOR)',
  '11-5122-01E (VERTICAL MID SUPPORT DOOR)',
  '11-5123-01E (BRACE BUCKET DOOR)',
  '11-5124-01E (CROSS BRACE TOP DOOR)',
  '11-5125-01E (BAR LATCH INNER)',
  '11-5126-01E (BAR LATCH OUTER)',
  '11-5127-01E (MTG PLATE LATCH)',
  '11-5128-01E (UPPR MTG BRKT 32 INCH DISP)',
  '11-5129-01E (GUSSET MID DOOR)',
  '11-5130-01E (HINGE MAIN DOOR)',
  '11-5131-01E (SUPPORT VERTICAL DOOR DISP)',
  '11-5132-01E (CROSS BAR 32 INCH DISP)',
  '11-5134-01E (SIDE BAR LEFT WATERFALL 20 BIN)',
  '11-5135-01E (SIDE BAR RIGHT WATERFALL 20 BIN)',
  '11-5136-01E (BRKT SIDE WATERFALL 20 BIN)',
  '11-5137-01E (HINGE WATERFALL DOOR 20 BIN)',
  '11-5141-01E (BOX MEDECO MAIN DOOR)',
  '11-5142-01E (CAB PANEL LEFT SIDE BSTR BAY TOUCH 20)',
  '11-5143-01E (CAB PANEL RIGHT SIDE BSTR BAY TOUCH 20)',
  '11-5144-01E (CAB HINGE SIDE DOOR TOUCH 20)',
  '11-5145-01E (CAB BOTTOM PLATE TOUCH 20)',
  '11-5146-01E (CAB BEAM BOTTOM REAR TOUCH 20)',
  '11-5147-01E (CAB BOTTOM FRONT BEAM TOUCH 20)',
  '11-5148-01E (CAB BEAM BOTTOM DEPTH TOUCH 20)',
  '11-5149-01E (CAB FLOOR TOUCH 20)',
  '11-5150-01E (CAB POST LEFT FRONT TOUCH 20)',
  '11-5151-01E (CAB POST RIGHT FRONT TOUCH 20)',
  '11-5152-01E (CAB POST LEFT REAR TOUCH 20)',
  '11-5153-01E (CAB POST RIGHT REAR TOUCH 20)',
  '11-5154-01E (CAB GUSSET BOTTOM SIDE TOUCH 20)',
  '11-5155-01E (CAB REAR/LEFT WALL TOUCH 20)',
  '11-5156-01E (CAB BEAM TOP WIDTH TOUCH 20)',
  '11-5158-01E (CAB BEAM TOP DEPTH TOUCH 20)',
  '11-5159-01E (CAB BEAM TOP DEPTH INNER TOUCH 20)',
  '11-5160-01E (CAB TOP PLATE TOUCH 20)',
  '11-5161-01E (CAB GUSSET TOP SIDE TOUCH 20)',
  '11-5162-01E (CAB BEAM L2 SIDE TOUCH 20)',
  '11-5163-01E (CAB BEAM L2 REAR TOUCH 20)',
  '11-5164-01E (CAB BEAM L2 FRONT TOUCH 20)',
  '11-5165-01E (CAB BEAM L2 MID TOUCH 20)',
  '11-5166-01E (CAB BEAM L2 SHORT TOUCH 20)',
  '11-5167-01E (CAB BURSTER SUPPORT RIGHT TOUCH 20)',
  '11-5168-01E (CAB BURSTER SHELF L2 TOUCH 20)',
  '11-5169-01E (CAB BEAM L3 RIGHT SIDE TOUCH 20)',
  '11-5170-01E (CAB GUSSET L3 RIGHT TOUCH 20)',
  '11-5171-01E (CAB SIDE DOOR PANEL TOUCH 20)',
  '11-5172-01E (CPU PLATE TOUCH 20)',
  '11-5173-01E (CAB PANEL FILLER BOX TOUCH 20)',
  '11-5174-01E (CAB CPU RAIL FRONT TOUCH 20)',
  '11-5175-01E (CAB CPU RAIL REAR TOUCH 20)',
  '11-5177-01E (CAB BEAM TOP WIDTH TOUCH 20)',
  '11-5180-01E (CAB LOWER FRONT GUSSET TOUCH 20)',
  '11-5181-01E (BRKT ANTENNA TOUCH 20)',
  '11-5182-01E (CAB BURSTER TOP TOUCH 20)',
  '11-5183-01E (CHANNEL UPPER MTG BEZEL 32 DISP)',
  '11-5185-01E (STIFFENER BEZEL TOP 32 DISP)',
  '11-5186-01E (CAB DRIP EDGE TOUCH 20)',
  '11-5187-301E (SHIELD REAR ETHERNET 20 BIN BLK)',
  '11-5188-01E (BRKT STOP 2D READER)',
  '11-5189-01E (HEAT SHIELD 32 INCH DISP)',
  '11-5190-01E (COVER REAR PANEL 20 BIN)',
  '11-5191-01E (ELECTRONICS DOOR PANEL 20 BIN)',
  '11-5192-01E (ELECTRONICS DOOR BRACKET 20 BIN)',
  '11-5193-01E (BURSTER CABLE GUIDE TOP TOUCH 20)',
  '11-5194-01E (CLIP BURSTER CABLE EE TRAY 20 BIN)',
  '11-5195-01E (COVER SENSOR MAIN DOOR 20 BIN)',
  '11-5196-01E (CABLE GUIDE TOUCH 20)',
  '11-5203-01E (CABINET LATCH HOOK LVM-3)',
  '11-5209-01E (COVER PANEL DBV B/A MASK 20 BIN)',
  '11-5210-01E (DRAWER FACE UPSTK DBV400 20 BIN)',
  '11-5211-01E (DRAWER SIDE RH UPSTK DBV400 20 BIN)',
  '11-5212-01E (DRAWER SIDE LH UPSTK DBV400 20 BIN)',
  '11-5213-01E (BASE MOUNT UPSTACK DBV400 20 BIN)',
  '11-5214-01E (BRKT LOCK UPSTACK DBV400 20 BIN)',
  '11-5215-01E (BRKT 2D READER 20 BIN)',
  '11-5217-01E (BILL ACCEPTOR MOUNTING PLATE TOUCH 20)',
  '11-5220-01E (BRKT DOOR SENSOR GEMINI TOUCH MINI)',
  '11-5222-01E (CAB CPU SUPPORT TOUCH 20)',
  '11-5223-01E (CAB BALLAST PLATE TOUCH 20)',
  '11-5224-01E (CAB CPU GROUND BKT TOUCH 20)',
  '11-5226-01E (CLAMP CABLE TOP BURSTER BOX)',
  '11-5228-01E (DEADBOLT CPU DOOR GAMETOUCH 20)',
  '11-5229-01E (PLATE CPU DOOR LATCH SHIELD)',
  '11-5230-01E (CABINET ALARM STUD PLATE GAME TOUCH 20)',
  '11-5231-01E (BRACE SHIELD PLATE DOOR)',
  '11-5232-01E (BRKT SECURITY DEADBOLT)',
  '11-5233-01E (REAR CABLE BRACKET GAMETOUCH 20)',
  '11-5234-01E (HANDLE BRKT DBV 400 GAMETOUCH 20)',
  '11-5265-01E (BRKT BUCKET BOARD CABLE SHELTER)',
  '11-5304-01E (SUB PANEL SNAP CASHLESS USB LVM3)',
  '11-5305-01E (PANEL REAR AC INPUT LVM3)',
  '11-5306-01E (BRKT BACKER COMM SNAP LVM3)',
  '11-5312-01E (COVER BUCKET BOARD GT20 3IN)',
  '11-5316-01E (DOOR CHUTE 3 IN 20 BIN)',
  '11-5317-01E (HINGE TICKET CHUTE 3 IN 20 BIN)',
  '11-5318-01E (BRACKET DOOR LOCK 3 IN 20 BIN)',
  '11-5319-01E (SIDE WALL RH PRINTER CHASSIS)',
  '11-5320-01E (SIDE WALL LH PRINTER CHASSIS)',
  '11-5321-01E (REAR WALL BASKET PRINTER CHASSIS)',
  '11-5322-01E (BASE PAN PRINTER CHASSIS)',
  '11-5324-01E (BRKT MTG PRINTER VKP80iii)',
  '11-5325-01E (PLATFORM SLIDING PRINTER)',
  '11-5326-01E (FRONT SUPPORT PRINTER CHASSIS)',
  '11-5327-01E (INNER SUPPORT PRINTER STAND)',
  '11-5328-01E (REAR SUPPORT PRINTER STAND)',
  '11-5329-01E (BASE STRUCTURE PRINTER STAND)',
  '11-5330-01E (FRONT WALL BASKET PRINTER CHASSIS)',
  '11-5333-01E (CAM LOCK W/ HOOK)',
  '11-5358-01E (BRKT PUSH PRINTER STAND)',
  '11-5362-01E (PLATE BASE CAM PRINTER)',
  '11-5363-01E (PLATE LH SECONDARY CAM PRINTER)',
  '11-5363-02E (PLATE RH SECONDARY CAM PRINTER)',
  '11-5364-01E (ARM TENSIONER LH)',
  '11-5364-02E (ARM TENSIONER RH)',
  '11-5365-01E (COUNTER WEIGHT PRINTER CAM)',
  '11-5368-01 (BRKT RS INTERNAL DISPLAY GT20)',
  '11-5369-01 (BRKT LS INTERNAL DISPLAY GT20)',
  '11-5390-01E (MOUNTING BRKT CASHLESS CVR P200 32”)',
  '11-5394-01E (CAB FRONT FACE PLATE GT20 7” DISP)',
  '11-5399-01E (CAB SIDE DOOR AND BA NUT PLATE GT20)',
  '12-0911-01E (MOUNT DOOR LATCH BUSHING EDSQ CABINET)',
  '12-0912-01E (BUSHING DOOR LATCH EDSQ CABINET)',
  '12-0919-01 (SHAFT LATCH ACCTHRM SUPREME)',
  '12-0920-01 (PIN DOWEL ACCTHRM SUPREME)',
  '12-0921-01 (CLUTCH ASSY MOLDED ACCTHRM SUPREME)',
  '12-0922-01 (ASSY STACKER SHAFT STD)',
  '12-0931-01E (BUSHING MOUNT DOOR LATCH ITVM)',
  '12-0937-01E (FRAME BASE QUAD BURSTER)',
  '12-0942-01E (SHAFT EXIT ROLLER DRIVE)',
  '12-0944-01E (BLADE FIXED QUADBURSTER)',
  '12-0944-02E (BLADE FIXED QUAD BURSTER)',
  '12-0951-01E (SHAFT SEGMENTED ROLLER)',
  '12-0964-01E (BLADE ROTATING BURSTER)',
  '12-0968-01E (SHAFT LONG IDLER ROLLER 8.5 RDR GT1200)',
  '12-0969-01E (SHAFT READER LATCH 8.5 RDR GT1200)',
  '12-0970-01E (SHAFT READER FRAME SUPPORT GT1200)',
  '12-0972-01E (SHAFT LCD LATCH GT1200)',
  '12-0976-01E (BUSHING STEEL LCD PIVOT GT1200)',
  '12-0977-01E (SHAFT IDLER ROLLER 8.5 RDR NO THP GT1200)',
  '12-0978-01E (SHAFT RDR PIVOT W/DEFLECTOR 8.5 GT1200)',
  '12-0980-01E (SHAFT CUTTER)',
  '12-0986-01E (PLUNGER INVENTORY PRESENT QUAD BURSTER)',
  '12-0987-01E (DOOR LATCH CAM LVM)',
  '12-0988-01E (DOOR LATCH DRIVE LINK LVM)',
  '12-0990-01E (BUSHING THREADED ADJUSTABLE FOOT LVM)',
  '12-0991-01E (KNOB THUMB SCREW LVM)',
  '12-0992-01E (MODIFICATION SHOULDER SCREW LVM)',
  '12-0993-01E (ROD ROLLER TICKET LVM)',
  '12-1036-01E (PIN)',
  '12-1046-01E (CAM MAIN DOOR LOCK LVM-2)',
  '12-1055-01E (SPACER .271L X.252 IDX.50 OD STL ZINC PL)',
  '12-1059-01E (SHAFT CIS MTG GT1200)',
  '12-1080-01E (SHAFT PULLEY DRIVE ADA BUCKET LVM)',
  '12-1081-01E (SPACER PULL SPRING ADA BUCKET LVM)',
  '12-1082-01E (ROLLER PULL SPRING ADA BUCKET LVM)',
  '12-1083-01E (IDLER WHEEL PULL ADA BUCKET LVM)',
  '12-1084-01E (SHAFT IDLER ADA BUCKET LVM)',
  '12-1086-01E (CROSSBAR EXTRUDED ADA BUCKET LVM)',
  '12-1088-01E (PULL EXTRUDED ADA TICKET BUCKET LVM)',
  '12-1090-01E (GUIDE RIGHT EXTRUDED ADA TICKET BCKT LVM)',
  '12-1090-02E (GUIDE LEFT EXTRUDED ADA TICKET BCKT LVM)',
  '12-1104-01E (SPACER FLAP ADA TICKET BUCKET LVM)',
  '12-1109-01E (SPACER .195 THK X 1.00 OD X .26 ID)',
  '12-1111-01E (ROLLER .55 LONG X.50 OD X .29 ID)',
  '12-1112-01E (ROLLER SLIDE BAR LATCH LVM-3)',
  '12-1113-01E (SPACER SLIDE BAR LATCH LVM-3)',
  '12-1114-01E (ROLLER LATCH LVM-3)',
  '12-1115-01E (ROLLER SPRING ASSIST LATCH LVM-3)',
  '12-1116-01E (SPACER SPRING ASSIST LATCH LVM-3)',
  '12-1117-01E (SPACER BEARING DEADBOLT LVM-3)',
  '12-1118-01E (SLIDE BRG DEADBOLT LVM-3)',
  '12-1122-01E (ROLLER ROCKER ARM LVM-3)',
  '12-1123-01E (SPACER ROCKER ARM PIVOT LVM-3)',
  '12-1135-01E (FLANGE DRAWER BASE UPSTK LVM-3)',
  '12-1136-01E (ROD TICKET ROLLER LVM-3)',
  '12-1931-01E (ROLLER .50 OD X .192 ID X .24L)',
  '12-1938-01E (PARALLEL PIN)',
  '12-1939-01E (PUSHER ARM DR)',
  '12-1940-01E (PUSHER ARM DL)',
  '12-1941-01E (GEAR SHAFT)',
  '12-1973-01E (SPACER LOCK 1" OD .75" ID .15" THICK)',
  '12-1974-01E (SPACER METRIC 4.2 ID 25 OD 5 L)',
  '12-1975-01E (CAM CPU DOOR LOCK SOUTHCO)',
  '12-1976-01E (CLEET CPU DOOR GAMETOUCH 20)',
  '12-1977-01E (SPACER CPU DOOR LATCH SM)',
  '12-1978-01E (SPACER CPU DOOR LATCH LG)',
  '12-1990-01E (ROLLER CAM TENSIONER ARM)',
  '12-1991-01E (BUSHING TENSIONER PRINTER)',
  '12-1992-01E (ROLLER TENSIONER PRINTER CHASSIS)',
  '12-1993-01E (SHAFT TENSIONER PRINTER CHASSIS)',
  '12-1994-01E (FLANGE CAM ARM PRINTER)',
  '12-1995-01E (SPACER SHOULDER CAM ARM PRINTER)',
  '13-0756-01 (FOOT RUBBER)',
  '13-0760-01E (ROLLER EXIT BURSTER)',
  '13-0911-01E (GROMMET EDGING .026-.062 SLOTTED WALL)',
  '13-0922-01E (EMI GASKET CHOMERICS SOFTSHIELD 3500)',
  '13-0966-01 (GEAR-PLATEN)',
  '13-0988-01E (SEAL TOUCHSCREEN GT1100)',
  '13-0988-01E (TOUCHSCREEN SEAL)',
  '13-0988-02E (TOUCH SCREEN 3.5 FT)',
  '13-1017-01E (WINDOW PROTECTIVE LCD LVM)',
  '13-1018-01E (PROTECTIVE LENS BUCKET ILLUMINATION PCB)',
  '13-1019-01E (RUBBER STOPPER PAD GT1200)',
  '13-1061-01E (FOAM PAD STOP ADA TICKET BUCKET LVM)',
  '13-1065-01E (WINDOW MYLAR GT1200-S)',
  '13-1068-01E (FOAM PAD .25 THK X .25 WIDE X 3.25 LONG)',
  '13-3016-01E (GASKET RUBBER BLK W/ADHESIVE TAPE GT1200)',
  '13-3017-01E (GASKET CONDUCTIVE 6MM W X .5MMTHK GT1200)',
  '13-3019-01E (PAD RUBBER 12MM DIA X 2MM THK LCD GT1200)',
  '13-3031-01E (TOUCHSCREEN GASKET 6.25 LG LVM)',
  '13-3031-02E (TOUCHSCREEN GASKET 4.25 LG LVM)',
  '13-3041-01E (GROMMET EDGE .50 X .188 LVM)',
  '13-3041-03E (GROMMET EDGE .50 X .188)',
  '13-3042-01E (WINDOW ENGINE TICKETSCAN PLUS)',
  '13-3043-01E (GASKET LCD TICKETSCAN PLUS HORIZONTAL)',
  '13-3043-02E (GASKET LCD TICKETSCAN PLUS VERTICAL)',
  '13-3045-01E (DISPLAY PROTECTION FILM TICKETSCAN PLUS)',
  '13-3046-01E (FILM W/2D RDR CUTOUT SIDE PANEL GT1200)',
  '13-3048-01E (FOAM CIS DUST GUARD GT1200)',
  '13-3049-01E (MODIFIED TIMING BELT ADA TICKET BCKT LVM)',
  '13-3050-01E',
  '13-3054-01E (GSKT CONDUCTVE w/ADHESV 10mmX10mm GT1200)',
  '13-3069-01E (BUSHING CABLE SPLIT .680 ID)',
  '13-3089-01E (MANUAL VOLUME CONTROL)',
  '14-1150-01E (LABEL LEFT SIDE GT1200 NEW YORK)',
  '14-1150-02E (LABEL RIGHT SIDE GT1200 NEW YORK)',
  '14-1150-03E (LABEL BACK GT1200 NEW YORK)',
  '14-3527-01E (LABEL LEFT SIDE FLEX GEORGIA)',
  '14-3527-02E (LABEL RIGHT SIDE FLEX GEORGIA)',
  '14-3527-03E (LABEL REAR COVER SIDE FLEX GEORGIA)',
  '15-1458-01 (ASSY PAPER JAM SENSOR ACCTHRM SUPREME)',
  '15-1459-01E (ASSY TOF SENSOR ACCTHRM SUPREME)',
  '15-1461-01 (ASSY PLATEN ACCTHRM SUPREME)',
  '15-1464-01 (ASSY LEFT BEARING PLATE ACCTHRM SUPREME)',
  '15-2661-01E (ASSY DOOR STOP GEMINI)',
  '15-3298-02E (ASSY EXIT ROLLER)',
  '15-3299-02E (ASSY FEED ROLLER)',
  '15-3402-01E (ASSY BURSTER ROLLER SEGMENT)',
  '15-3482-01E (ROLLER DRIVE TPH PLATEN 8.5 RDR GT1200)',
  '15-3483-01E (ROLLER DRIVE RDR TRANSPORT 8.5 GT1200)',
  '15-3485-01E (ASSY FRAME LCD PIVOT GT1200)',
  '15-3486-01E (ASSY HINGE LEFT LCD GT1200)',
  '15-3487-01E (ASSY HINGE RIGHT LCD GT1200)',
  '15-3488-60E (LEFT SIDE PANEL GT1200 IMAGINE SILVER)',
  '15-3488-60E (LEFT SIDE PANEL GT1200 IMAGINE SILVER)',
  '15-3489-60E (RIGHT SIDE PANEL GT1200 IMAGINE SILVER)',
  '15-3489-60E (RIGHT SIDE PANEL GT1200 IMAGINE SILVER)',
  '15-3490-60E (STACKER STOP GT1200 IMAGINE SILVER)',
  '15-3490-60E (STACKER STOP GT1200 IMAGINE SILVER)',
  '15-3491-60E (PUSH BUTTON LCD GT1200 IMAGINE SILVER)',
  '15-3491-60E (PUSH BUTTON LCD GT1200 IMAGINE SILVER)',
  '15-3500-01E (ASSY PIN SHAFT CUTTER)',
  '15-3509-01E (ASSY FRAME TERMINAL CHASSIS GT1200)',
  '15-3518-01E (ASSY CUTTER SHAFT PIN DRIVE)',
  '15-3522-01E (ASSY REAR COVER PLUNGER)',
  '15-3526-01E (ASSY QB BOX LVM)',
  '15-3528-301E (ASSY CABINET LVM BLACK PEEL)',
  '15-3535-01E (ASSY CONTACT IMAGE SENSOR GT1200)',
  '15-3535-01E (ASSY CONTACT IMAGE SENSOR GT1200)',
  '15-3536-01E (ASSY MAIN DOOR PANEL LVM)',
  '15-3537-01E (ASSY DRAWER COMPLETE LVM)',
  '15-3537-02E (ASSY DRAWER EXT. TRAVEL COMPLETE)',
  '15-3540-01E (ASSY PUSH BUTTON INSTANT TICKET LVM)',
  '15-3542-01E (ASSY CABINET & DOOR LVM)',
  '15-3542-02E (ASSY CABINET & DOOR LVM W/BETSLIP HOLES)',
  '15-3557-01E (ASSY BATTERY HOLDER WELDMENT GEM-T28)',
  '15-3600-01E (ASSY QUAD BURSTER COMPLETE)',
  '15-3604-01E (ASSY DOOR ENCL ELECTRONICS LVM)',
  '15-3605-01E (ASSY ENCL ELECTRONICS LVM)',
  '15-3607-00E DRW 000 00 (ASSY WELDMENT QUICK PICK 6 CHASSIS LVM)',
  '15-3607-01E (ASSY WELDMENT QP6 CHASSIS LVM SMOOTH BLK)',
  '15-3615-01E (BILL ACCEPTOR DOOR COMPLETE DBV LVM)',
  '15-3616-00E DRW 000 01 (ASSY BILL ACCEPTOR COMPLETE DVB LVM)',
  '15-3616-02E (ASSY B/A COMP DBV 1000 NOTE LVM)',
  '15-3619-01E (ASSY BURSTER DRAWER MODULE LVM)',
  '15-3624-01E (ASSY LOCK BOX STORAGE LVM)',
  '15-3636-03E (INSTANT TICKET CROSS BRACE 8LED/NO RES)',
  '15-3637-03E (INSTANT TKT CROSS BRACE TOP 8LED/NO RES)',
  '15-3638-01E (ASSY INSTANT TICKET CROSS BRACE BOT LVM)',
  '15-3645-318E (WELDMENT CROSS BRACE STFFNR WET WHT LVM)',
  '15-3646-000E DRW 000 00 (WELDMENT CROSS BRACE STIFFENER TOP LVM)',
  '15-3646-318E (WELDMENT CROSS BRACE STFFNR TOP WET WHT)',
  '15-3647-01E (ASSY PANEL TOP ENCLOSURE LVM)',
  '15-3676-01E (WELDMENT PEN HLDR FRNT PNL BET SLIP HLDR)',
  '15-3677-01E (ASSY REAR COVER QUICKPICK 6 LVM)',
  '15-3678-302E (ASSY FRONT PLATE QUICKPICK 6 LVM BLACK)',
  '15-3681-02E (ASSY QP DOOR SW / ALARM MUTE LVM)',
  '15-3705-01E (ASSY FIXED RAMP LOWER LVM)',
  '15-3717-53E (ASSY CONTROLLER LVM ATOM ADA 2GB 2GB)',
  '15-3718-58E (ASSY ELECTR ENCL COMP ADA 2GB 2GB W/LOCK)',
  '15-3721-01E (ASSY IMAGER SCANNER COMPLETE LVM)',
  '15-3723-01E (ASSY LCD 6.5IN W/ TOUCHSCREEN LVM)',
  '15-3724-01E (PRINTER MOUNT COMPLETE ULTRA LVM)',
  '15-3727-01E (ASSY TKT BUCKET WELDMENT ULTRA PTR LVM)',
  '15-3731-01E (ASSY DOOR RAMP BRKT LVM)',
  '15-3776-01E (ASSY CABLE GUIDE WELDMENT LVM)',
  '15-3929-01E (BACKPLATE WELDMENT COMPL TICKETSCAN PLUS)',
  '15-3941-570E (ASSY BEZEL TICKETSCAN PLUS GREEN)',
  '15-3942-01E (ASSY BAFFLE TICKETSCAN PLUS)',
  '15-3945-01E (ASSY CIS LITEPIPE GT1200)',
  '15-3954-01E (WLDMT LEFT SIDE PNL BETSLIP HLDR GEMINI)',
  '15-3955-301E (ASSY WLDMT BETSLIP 48" GEMINI BLK PEEL)',
  '15-3956-01E (ASSY BETSLIP HLDR 48" GEMINI BLACK)',
  '15-3966-01E (ASSY ELECTRONICS ENCLOSURE W/DOOR GEMINI)',
  '15-3967-01E (LEFT SIDE PNL GT1200 SILVER W/2DRDR FILM)',
  '15-3968-01E (RIGHT SIDE PNL GT1200 SILVERW/2DRDR FILM)',
  '15-3972-01E (ASSY ADA GENERIC TICKET BUCKET)',
  '15-3982-01E (ASSY FLAP ADA BUCKET LVM)',
  '15-3983-01E (ASSY PULL MECH SIDE WALL ADA BUCKET LVM)',
  '15-3985-01E (ASSY SHAFT ADA BUCKET LVM)',
  '15-3986-01E (ASSY CROSS STRUCTURE ADA BUCKET LVM)',
  '15-3989-01E (ASSY BUCKET ILLUMINATION BRACKET)',
  '15-3992-01E (ASSY PULL W/ PINS ADA TICKET BUCKET LVM)',
  '15-3993-01E (ASSY PULL BRG BELT ADA TICKET BUCKET LVM)',
  '15-4001-01E (ASSY TICKET CHUTE DOOR W/STIFFENER)',
  '15-4015-37E (ASSY QP W/BUTTONS GEMINI ADA WISCONSIN)',
  '15-4017-01E (KIT FIXED BLADE REPAIR ACCUTHERM SUPREME)',
  '15-4022-37E (ASSY CABINET COMP GEMINI ADA WISCONSIN)',
  '15-4105-02E',
  '15-4105-03',
  '15-4117-01E (ASSY ROCKER ARM WATERFALL LVM-3)',
  '15-4133-01E (ASSY TOUCHSCREEN MOUNTING PLATE GEMT 28)',
  '15-4145-01E (ASSY LWR MTG BRKT 32 IN DISPLAY)',
  '15-4146-01E (ASSY BAR LATCH)',
  '15-4147-01E (ASSY LATCH MAIN DOOR)',
  '15-4148-01E (ASSY WELDMENT WATERFALL 20 BIN)',
  '15-4152-01E (ASSY WATERFALL DOOR AND HINGE)',
  '15-4155-01E (ASSY WELDMNT DOOR GAMETOUCH 20)',
  '15-4157-01E (ASSY 32 INCH DISPLAY W/ BASE)',
  '15-4162-01E (ASSY RIVETED REAR COMM PANEL LVM3)',
  '15-4164-01E (ASSY BUCKET BOARD COVER GT20 3IN)',
  '15-4168-01E (ASSY RIVETED PRINTER STAND)',
  '15-4171-01E (ASSY REAR PANEL WITH INSERTS)',
  '15-4175-01E (ASSY CHUTE DOOR 3IN 20 BIN)',
  '15-4176-01E (ASSY CHUTE DOOR AND HINGE 3 IN 20 BIN)',
  '15-4177-01E (ASSY CHUTE BRKT LOCK 3 IN 20 BIN)',
  '15-4180-301E (ASSY MAIN DOOR AND HINGE BLK G-TOUCH 20)',
  '15-4181-01-01 (CHASSIS PRINTER PAINT WHITE SMOOTH)',
  '15-4181-01E (ASSY WELDMENT CHASSIS PRINTER)',
  '15-4182-01E (ASSY SLIDING PRINTER STAND)',
  '15-4183-01E (ASSY ROLL HOLDER PRINTER MOUNT)',
  '15-4184-01E (ASSY ROCKER MODULE ROLL HOLDER)',
  '15-4185-01E (ASSY PIVOT MODULE LEFT)',
  '15-4185-02E (ASSY PIVOT MODULE RIGHT)',
  '15-4189-301E (ASSY WELDMENT CABINET GT20 7" DISP BLK)',
  '15-4203-01E (ASSY CABINET DOOR LATCH LVM)',
  '15-4204-01E (DOOR LATCH MOUNTING BRKT LVM)',
  '15-4218-01E (ASSY SECURITY SENSOR W/BRACKET LVM-3)',
  '15-4223-01E (ASSY DOOR SWITCH W/BRACKET GEMINI TOUCH)',
  '15-4229-01E (ASSY ESMM 15 INCH NLT DISPLAY GEMINI)',
  '15-4255-01E (ASSY ENCL COMP TICKETSCAN PLUS TIVA)',
  '15-4277-302E (PERIPHERAL PANEL ADA DBV 2D GEMINI BLACK)',
  '15-4311-01E (ASSY UPSTACK SLIDE CHASSIS 20 BIN)',
  '15-4312-01E (ASSY DRAWER UPSTK DBV400 20 BIN)',
  '15-4313-01E (ASSY BASE MOUNT UPSTK DBV400 20 BIN)',
  '15-4317-01E (ASSY ELECTRONICS DOOR 20 BIN SCREWDRIVER)',
  '15-4464-01 (ASSY ELECTRONICS ENCLOSURE WELDMENT)',
  '15-4472-01 (ASSY ELECTRONICS ENCLOSURE KABY LAKE)',
  '15-4480-01 (ASSY EE KABY MB COMPLETE 8GB/32GB)',
  '15-5190-01E (ASSY CAB PURCHASE GT20 3” CHUTE 7” DISP)',
  '15-5191-04E (ASSY CABINET COMP GT20 KABY WISCONSIN)',
  '15-9104-03E (ASSY FEED ROLLER QUAD BURSTER)',
  '16-1794-01 (ASSY PAPER COVER ACCTHRM SUPREME GRAY)',
  '16-1795-01 (ASSY MIDFRAME ACCTHRM SUPREME GRAY)',
  '16-1796-01E (ASSY RT BEARING PLATE/PLNGR ACCTHRM SUP)',
  '16-1797-01 (ASSY LFT BEARING PLATE/PLNGR ACCTHRM SUP)',
  '16-1798-01 (ASSY BASE FRAME ACCTHRM SUPREME GRAY)',
  '16-1799-01 (FRAME TENSIONER ACCTHRM SUPREME)',
  '16-1801-01 (FLAG PAPER OUT/COVER OPEN ACCTHRM SUP)',
  '16-1802-01 (SLACKER PAPER ACCTHRM SUPREME)',
  '16-1803-01 (LATCH LEFT ACCTHRM SUPREME)',
  '16-1804-01E (LATCH RIGHT ACCTHRM SUPREME)',
  '16-1805-01E (LEVER COVER RELEASE ACCTHRM SUPREME)',
  '16-1806-01 (ROLLER IDLER ACCTHRM SUPREME)',
  '16-1809-01 (GEAR COMBO 14-28 ACCTHRM SUPREME)',
  '16-1810-01E (ASSY STACKER FRAME/PIN STD ACCTHRM SUP)',
  '16-1811-01 (HOLDER HEAD SPRING ACCTHRM SUPREME)',
  '16-1812-01 (ASSY MOUNT PAPER PATH/FLAG ACCTHRM SUP)',
  '16-1813-01 (GEAR COMBO 26/46 DRIVE ACCTHRM SUPREME)',
  '16-1814-01 (GEAR COMBO 48/28 IDLER ACCTHRM SUPREME)',
  '16-1824-566E',
  '16-1848-01E (GEAR CAM BURSTER)',
  '16-1866-561E (COVER BUTTON)',
  '16-1866-561E (LCD BEZEL GT1100 IMAGINE BLACK)',
  '16-1889-01E (BURSTER ROLLER SEGMENT)',
  '16-1890-01E (BEARING SEGMENTED ROLLER SHAFT)',
  '16-1915-561E (BASE GT1200 IMAGINE BLACK)',
  '16-1915-561E (BASE GT1200 IMAGINE BLACK)',
  '16-1917-561E (RAMP STACKER GT1200 IMAGINE BLACK)',
  '16-1917-561E (RAMP STACKER GT1200 IMAGINE BLACK)',
  '16-1918-561E (REAR COVER 8.5" RDR GT1200 IMAGINE BLACK)',
  '16-1918-561E (REAR COVER 8.5" RDR GT1200 IMAGINE BLACK)',
  '16-1919-561E (CABLE COVER GT1200 IMAGINE BLACK)',
  '16-1919-561E (CABLE COVER GT1200 IMAGINE BLACK)',
  '16-1920-01E (GUIDE LCD LATCH BAR GT1200)',
  '16-1922-561E (COVER LCD BUTTON 8.5" RDR GT1200 BLK)',
  '16-1922-561E (COVER LCD BUTTON 8.5" RDR GT1200 BLK)',
  '16-1923-01E (BUSHING LCD LATCH BAR GT1200)',
  '16-1924-01E (BUSHING LCD PIVOT GT1200)',
  '16-1926-561E (HOUSING LCD BACK GT1200 IMAGINE BLACK)',
  '16-1926-561E (LCD BACK COVER)',
  '16-1927-01E (GEAR IDLER 45 TOOTH GT1200)',
  '16-1928-01E (INFEED GUIDE TRANSPORT LOWER 8.5"RDR)',
  '16-1929-01E (ASSY INFEED GUIDE TRANSPORT UPPER GT1200)',
  '16-1930-01E (PLATTEN PAD RIGHT GT1200)',
  '16-1931-01E (PLATTEN PAD LEFT GT1200)',
  '16-1932-01E (BRACKET IDLER ROLLER GT1200)',
  '16-1933-01E (ROLLER IDLER GT1200)',
  '16-1936-01E (M-BUSHING BUTTON READER)',
  '16-1937-01E (CVR INFEED GUIDE TRANSPORT LOWER GT1200)',
  '16-1943-01E (PUSH BUTTON HOOK READER GT1200)',
  '16-1944-01E (PUSH BUTTON READER GT1200)',
  '16-1945-01E (GEAR IDLER 64-32 GT1200)',
  '16-1946-01E (BUSHING SPRING READER PIVOT GT1200)',
  '16-1947-01E (GEAR DRIVE ROLLER 25 TOOTH GT1200)',
  '16-1948-01E (GEAR IDLER 60 TOOTH GT1200)',
  '16-1949-01E (GEAR IDLER 25 TOOTH GT1200)',
  '16-1953-01E (BUSHING INSIDE READER PIVOT SHAFT GT1200)',
  '16-1954-01E (BUSHING OUTSIDE RDR PIVOT SHAFT GT1200)',
  '16-1955-01E (BUSHING DRIVE ROLLER SPRING 8.5" RDR)',
  '16-1956-01E (BUSHING PLATTEN ROLLER SPRING 8.5" RDR)',
  '16-1959-01E (INFEED GUIDE TRANSPORT UPPER W/O BRAND)',
  '16-1976-01E (SELECTOR PUSH BUTTON INSTANT TICKET)',
  '16-1977-01E (BACKER PUSH BUTTON WHITE)',
  '16-1978-01E (CARRIER INSTANT TICKET LVM)',
  '16-1979-01E (BUSHING PUSH BUTTON LVM)',
  '16-1989-01E (TICKET DEFLECTOR GT1200)',
  '16-2051-561E (HOLDER 2D RDR DS6707 BLACK)',
  '16-2053-561E (HOOD IMAGER SCANNER IMAGINE BLACK LVM)',
  '16-2079-01E (MOTOR GUIDE AR)',
  '16-2080-01E (MOTOR GUIDE BR)',
  '16-2081-01E (FRAME DBV)',
  '16-2107-569E (ENCLOSURE TICKETSCAN PLUS-CYCOLOY BLACK)',
  '16-2109-570E (BEZEL TICKTSCAN PLUS LEXAN TSP GREEN)',
  '16-2111-01E (BAFFLE READER ENGINE TICKETSCAN PLUS)',
  '16-2118-561E (2D BARCODE LENS WINDOW CVR BLACK GT1200)',
  '16-2121-01E (END BRKT MTG CIS LTPIPE GT1200)',
  '16-2123-01E (ASSY PAPER COVER ACCTHRM SUPREME BLACK)',
  '16-2124-01E (ASSY BASE FRAME ACCTHRM SUPREME BLACK)',
  '16-2125-01E (ASSY MIDFRAME ACCTHRM SUPREME BLACK)',
  '16-2126-01E (RACK ARC SPUR GREA ADA BUCKET LVM)',
  '16-2127-01E (RACK SPUR DAMPENER ADA BUCKET LVM)',
  '16-2128-01E (MAIN FIXED BODY ADA BUCKET LVM)',
  '16-2129-01E (MAIN MOVING FLOOR ADA BUCKET LVM)',
  '16-2130-01E (HANDLE PULL ADA BUCKET LVM)',
  '16-2131-01E (WHEEL BRG ADA TICKET BUCKET LVM)',
  '16-2135-561E (BEZEL LCD 15" SAW TS GT1200)',
  '16-2138-561E (BACK LCD 15" GT1200 RIGHT USB)',
  '16-2148-01E (SPACER FAN CPU DRAWER GT1200)',
  '16-2149-571E (HANDLE MAIN DOOR LVM-3 BLACK)',
  '16-2154-01E (LOWER GUIDE COVER)',
  '16-2156-561E (BASE BLACK FLEX 1500)',
  '16-2157-561E (RAMP BLACK FLEX T-1500)',
  '16-2163-01E (TRAY READER UP)',
  '16-2174-01E (WORM GEAR)',
  '16-2176-01E (GEAR E R)',
  '16-2177-01E (GEAR D R)',
  '16-2193-01E (TRAY RDR UP W/TPH)',
  '16-2195-01E (FOOT CAP LVM-3 28)',
  '16-2203-01E (GUIDE SENSOR BD)',
  '16-2204-01E (CABLE CLAMP ARRAY 28 BIN)',
  '16-2211-561E (REAR COVER FLEX BLACK 2.0)',
  '16-2238-577E (PANEL LEFT SIDE W/ILLUM FLEX)',
  '16-2243-577E (PANEL RIGHT SIDE W/ILLUM FLEX)',
  '16-2262-03-03 (PAINTED BZL DOOR P200 GT20 PAN 185C RED)',
  '16-2262-03E (BEZEL FRONT DOOR P200 GAMTOUCH 20)',
  '16-2264-01E (ANTENNA COVER GAMETOUCH 20)',
  '16-2265-01E (HOLDER 2D READER DS4308)',
  '16-2284-01-03 (PNTD CASHLESS CVR P200 GT20 PAN 185C RED)',
  '16-2284-01E (ADA CASHLESS COVER GAMETOUCH 20)',
  '16-352-0127-01E (DISC ENCODER QUAD BURSTER)',
  '17-0167-01E (CLAMP CABLE 3/8 WIDE X 3/16 DIA)',
  '17-0344-01E (BATTERY HOLDER 6 VOLT LITHIUM)',
  '17-0344-02E (BATTERY HOLDER 6 VOLT LITHIUM)',
  '17-0362-01E (HOLDER LED BLACK SCREW-TYPE)',
  '17-0362-02E (HOLDER LED BLACK SCREW TYPE LONG)',
  '17-0391-01E (FOOT BLK .50SQX.22HGT SELF ADHESIVE)',
  '17-0736-01 (CLUTCH ROLLER BEARING)',
  '17-0805-01E (GUARD FAN GT602)',
  '17-0856-01E (TIES CABLE STUD MOUNT RELEASABLE BLK NYL)',
  '17-0908-12E (DRAWER SLIDE EDS-Q BURSTER)',
  '17-0941-01 (SPRING COMPRESSION ACCTHRM SUPREME)',
  '17-0943-01 (SPRING EXTENSION PAPER SLACKER)',
  '17-0944-01 (SPRING LATCH ARM EXT ACCTHRM SUPREME)',
  '17-0945-01 (SPRING COMP STACKER TENSION ACCTHRM SUP)',
  '17-0946-01 (SPRING COMP PRINTHEAD ACCTHRM SUPREME)',
  '17-1002-01E (SNACKMASK KIT JCM DBV-300)',
  '17-1008-02E (RUBBER CAP SAFETY LATCH  GREEN)',
  '17-1012-01E (FOOT RUBBER GT1100)',
  '17-1012-01E (FOOT RUBBER GT1100)',
  '17-1021-01E (O-RING .484 ID X .139W DBL SEAL BUNA  N)',
  '17-1053-01E (SPRING COMP IDLER ROLLERS GT1200)',
  '17-1054-01E (SPRING COMP CIS GT1200)',
  '17-1055-01E (SPRING EXTN RDR LATCH SHAFT GT1200)',
  '17-1056-01E (SPRING COMP READER PIVOT GT1200)',
  '17-1057-01E (SPRING COMP 8.5 RDR DRIVE ROLLERS GT1200)',
  '17-1058-01E (SPRING EXTENSION LCD LATCH GT1200)',
  '17-1059-01E (BEARING DRIVE ROLLERS 8.5IN RDR GT1200)',
  '17-1061-01E (FILTER GT1200)',
  '17-1062-01E (CLAMP CABLE 9.0MM DIA GT1200)',
  '17-1063-01E (CLAMP CABLE 6.4MM DIA GT1200)',
  '17-1064-01E (CLAMP WIRE 11.5MM WIDE OPENING GT1200)',
  '17-1065-01E (CLAMP WIRE 6.6MM WIDE OPENING GT1200)',
  '17-1069-01E (CLIP C RETAINING PLSTC 5.20MM ID GT1200)',
  '17-1070-01E (CLIP C RETAINING PLSTC 3.10MM ID GT1200)',
  '17-1092-01E (BUSHING FLANGED M250 .625 DIA)',
  '17-1094-01E (BUSHING CLIP .500 DIA)',
  '17-1095-01E (HINGE CONTINUOUS LVM)',
  '17-1096-01E (ADJUSTABLE FOOT LVM)',
  '17-1097-01E (LATCH CAM LOCK LVM)',
  '17-1098-03E (SPRING COMP.180 ODX.25 +/-.020 .011 WIRE)',
  '17-1100-01E (E-RING TICKET DEFLECTOR GT1200)',
  '17-1101-01E (SPRING EXT .180 OD X1.00FREE LG .029WIRE)',
  '17-1102-01E (DOOR HANDLE POP-OUT NO LOCK LVM)',
  '17-1103-01E (HINGE SLIP .120 PIN DIA MALE)',
  '17-1104-01E (HINGE SLIP .120 PIN DIA FEMALE)',
  '17-1105-01E (CAM MEDECO CT-D04)',
  '17-1106-01E (CLAMP FLAT CABLE LVM)',
  '17-1108-01E (HINGE BILL ACCEPTOR DOOR LVM)',
  '17-1111-01E (HOLE PLUG LIQUID TIGHT .75 DIA LVM)',
  '17-1112-02E (STRECHABLE RUBBER TIEDOWN 21IN)',
  '17-1122-01E (CABLE CLAMP 3/16IN DIA X 3/8IN WIDE)',
  '17-1125-01E (CLAMP CABLE .75DIA X.50W SANTOPRENE)',
  '17-1132-01E (SPRING COMP WAVE .50ID.312IDX.42FREE HGT)',
  '17-1149-01E (BRUSH ANTISTATIC COND ACRYLIC80MMX11.5MM)',
  '17-1159-01E (CLAMP CABLE FLAT .25 X 1.50)',
  '17-1161-02E (DUST CAP USB TYPE-A JACK)',
  '17-1171-01E (HOLE PLUG .313" .318" HOLE TRUSS HD LVM2)',
  '17-1175-01E (STRIP ADHESIVE MYLAR COVER GT1200)',
  '17-1176-01E (SEMI ELLIPSE ADHESIVE MYLAR COVER GT1200)',
  '17-1177-01E (ROUND ADHESIVE MYLAR COVER)',
  '17-1186-01E (SPRING CONSTANT FORCE ADA BUCKET LVM)',
  '17-1187-01E (BELT TIMING ADA BUCKET LVM)',
  '17-1188-01E (PULLEY TIMING ADA BUCKET LVM)',
  '17-1189-01E (ROTARY DAMPER ADA BUCKET LVM)',
  '17-1199-01E (PAD PROTECTION 15" LCD GT1200)',
  '17-1200-01E (PAD DUSTPROOF 15" LCD GT1200)',
  '17-1203-01E (SPRING EXT .36 OD X 1.00 FREE LG .055 D)',
  '17-1207-01E (SPRING EXT .24 OD X .75 FREE X .037 WIRE)',
  '17-1208-01E (SPRING COMP .420 OD .310 ID .88 FREE)',
  '17-1211-01E (DRAWER SLIDE 17 IN LVM-3)',
  '17-1213-01E (SECURITY COLLAR MAIN DOOR LOCK LVM-3)',
  '17-1222-01E (CASH BOX DBV-400 1000 NOTE)',
  '17-1227-01E (ROLLER A DBV-300)',
  '17-1228-01E (COMPRESSION SPRING ROCKER ARM 28 BIN)',
  '17-1231-03E (WIRE TIE 1.00 LOOP)',
  '17-1231-04E (WIRE TIE HARNESS BLACK)',
  '17-1233-01E (SPRING WAVE WASHER ROCKER ARM LVM-3)',
  '17-1249-01E (EMI SHIELD COPPER FINGERS LVM-3)',
  '17-1254-01E (RUBBER CAP VERIFONE DONGLE CONNECTOR)',
  '17-1267-01E (LEVELING AID WEDGES BLACK)',
  '17-1269-01E (HANDLE ROUND GRIP M4)',
  '17-1270-01E (DRAWER SLIDE 380MM EXTENSION)',
  '17-1271-01E (TWIST TIE .75 BUNDLE)',
  '17-1273-01E (SPRING LATCH TOUCH 20)',
  '17-1274-01E (CLIP FLAT CABLE 2.1" L X .43” H GT20)',
  '17-1278-01E (CURVED WASHER .25"ID .45"OD .091"-.030"H)',
  '17-1284-01E (TORSION SPRING LH TENSIONER)',
  '17-1285-01 (FAN COMPUTER ASSY 60CFM 80*80*25MM)',
  '17-1289-01E (ROCKER PAPER HOLDER CUSTOM)',
  '17-1290-01E (ROLLER PAPER HOLDER CUSTOM)',
  '17-1294-01E (SHAFT STOP IDLER ROLL HOLDER)',
  '17-1295-01E (SHAFT ROCKER PIVOT ROLL HOLDER)',
  '17-1296-01E (RETAINING RING E-CLIP 3MM TO 4MM SHFT)',
  '17-1297-01E (RETAINING RING E-CLIP 4MM TO 5MM SHFT)',
  '17-1298-01E (SHAFT IDLER ROLL HOLDER)',
  '17-1302-01 (GROMMET W/ LOCKING ID 0.5 OD 0.625)',
  '17-1303-01E (BUMPER RUBBER .625 DIA x .500 x 8-32)',
  '17-1304-01E (WAVE WASHER .252 ID)',
  '17-1305-01E (TORSION SPRING RH TESNIONER)',
  '17-372-0004-04E (CLAMP CABLE .500 DIA X .50W)',
  '20-0266-02E (SWITCH DPST ROCKER 22A HISURGE 125VAC)',
  '20-0382-01E (SWITCH SPDT PUSH BTN .1A 125V)',
  '20-1200-01E (SPEAKER 2.0 INCH SHIELDED)',
  '20-1213-01E (SWITCH SPDT ON-MOM PLUNGER)',
  '20-1247-01E (ASSY PRINTHEAD ACCTHRM SUPREME)',
  '20-1248-01E (ASSY KNIFE MOTOR ACCTHRM SUPREME)',
  '20-1249-01 (ASSY LINE FEED MOTOR ACCTHRM SUPREME)',
  '20-1266-01E (ASSY MOTOR CUTTER/EXIT 4X,BURSTER)',
  '20-1288-01E (HEATSINK CPU/GMCH GT1200)',
  '20-1289-01E (POWER BUTTON/INDICATOR GT1200)',
  '20-1289-03E (POWER BUTTON/INDICATOR 15IN DISP GT1200)',
  '20-1295-02E (SWITCH SPST GOLD MOM WHT PB PANEL MOUNT)',
  '20-1295-03E (SWITCH SPST MOM BLK PANEL MOUNT)',
  '20-1297-01E (MOTOR STEPPER GT1200)',
  '20-1298-03E (SM SWITCH PB SPST 6MM X 6MM 100GF)',
  '20-1298-04E (SWITCH PB SPST 6MM X 6MM 5.0MM HGT 150GF)',
  '20-1300-01E (SWITCH SPDT MINI SNAP-ACTION)',
  '20-1303-01E (SWITCH DIP 8 POS SIDE ACTUATED)',
  '20-1304-02E (SWITCH SPDT LEVER ROLLER SOLDER TAB)',
  '20-1306-01E (SWITCH SECONDARY PLAYER INPUT GEMINI)',
  '20-1312-01E (SWITCH DPST ROCKER 16A HISURGE 250V NEON)',
  '20-1319-01E (ASSY KEYPAD ONLINE GAMES GEMINI ADA)',
  '20-1329-01E (ALARM PIEZO PNL MNT 3-7 VDC 4-12MA)',
  '20-630-0001-01E (SWITCH SPDT ROLLER LEVER ACTR SUBMINI)',
  '21-1497-02E (FUSE SM 1.1 AMP 30V PTC)',
  '21-1542-03E (CONN 5POS JST 2.0MM)',
  '21-1547-02E (CONN SKT 24-30AWG AU JST 2.0MM)',
  '21-2065-01E (CONN SM 4POS STR HDR DBLROW)',
  '21-2250-01E (CONN 9POS MATE N LOCK)',
  '22-1661-01E (BOARD QUAD BURSTER EXIT SENSOR)',
  '22-1780-01E (BOARD QUAD BURSTER CONTOLLER BD LVM)',
  '22-1781-01E (BOARD INSTANT PRICE DISPLAY CONTR LVM)',
  '22-1783-01E (BOARD INSTANT PRICE DISPLAY NUMERIC LVM)',
  '22-1784-01E (BOARD LCD/TOUCH INTERFACE LVM)',
  '22-1794-01E (PCB LED BD GT1200)',
  '22-1800-01E (BOARD POWER INTEGRATION LVM)',
  '22-1807-01E (BOARD QUICK PICK 6 LED LVM)',
  '22-1865-01E (BOARD INST PRICE DISPLAY 8 LED LVM)',
  '22-1866-01E (BOARD TICKET BIN LIGHTING 4 LED LVM)',
  '22-1867-01E (BOARD SCSI BREAKOUT (ATOM)  LVM)',
  '22-1868-01E (BOARD SECURITY INTEGRATION (ATOM)  LVM)',
  '22-1869-01E (BOARD QUICK PICK 6 CNTRL (ATOM) LVM)',
  '22-1871-01E (BOARD PCI TO USB LVM)',
  '22-1891-01E (BOARD CIS CONTROLLER BD GT1200CR)',
  '22-1896-01E (BOARD ADA KEYPAD &  BUCKET MTR XFACE)',
  '22-1930-01E (nan)',
  '22-1942-01E (PCB SCSI I/O BD GEMINI TOUCH28)',
  '23-0018-01E (BATTERY 6V LITHIUM DL223A)',
  '231395 (STACKER GEAR B)',
  '231424 (MOTOR ENCODER)',
  '231445 (PUSHER ARM B)',
  '231461 (PUSHER ROLLER)',
  '231474 (PUSHER SHAFT A)',
  '236946 (STACKER ARM)',
  '236948 (STACKER GEAR A)',
  '238010 (MOTOR HARNESS ASSY)',
  '24-0488-02E (ASSY SECURITY LED)',
  '24-0766-01E (ASSY FEED MOTOR QUAD BURSTER)',
  '24-0771-01E (ASSY DUAL SPEAKER GT1100/1200)',
  '24-0771-01E (ASSY DUAL SPEAKER GT1100/1200)',
  '24-0786-01E (ASSY FILTER (DUAL STAGE) PWR LINE W/CONN)',
  '24-0803-01E (ASSY SHIELD REAR ETHERNET 20 BIN BLK)',
  '24-1621-03E (ASSY ALARM DISABLE SWITCH LVM-3)',
  '24-1622-01E (ASSY CABLE TILT SWITCH)',
  '24-1623-04E (ASSY ALARM PIEZO 3-7 VDC LVM-3)',
  '24-1626-02E (ASSY SPEAKER W/CABLE GAMEPOINT)',
  '24-1626-04E (ASSY SPEAKER W/CABLE LVM-3)',
  '24-1627-01E (ASSY SECURITY SENSOR SST)',
  '24-1641-02E (ASSY REMOTE COMPONENTS GAMEPOINT 433MHZ)',
  '24-1655-01E (ASSY CUTTER HOME SWITCH QUAD BURSTER)',
  '24-1664-01E (ASSY DUAL BATTERY LVM-3)',
  '24-1725-01E (ASSY READER 8.5IN W/O BRANDER GT1200)',
  '24-1725-03E (ASSY RDR 8.5 LTPIPE W/O BRND GT1200)',
  '24-1726-01E (READER)',
  '24-1727-01E (INFEED GDE TRNSPRT LOWER 8.5 RDR GT1200)',
  '24-1728-03E (ASSY TRAY UP W/O BRND 8.5 LTPIPE GT1200)',
  '24-1731-01E (ASSY THERMAL PRINT HEAD GT1200)',
  '24-1741-01E (ASSY SYSTEM FAN GT1200)',
  '24-1741-01E (ASSY SYSTEM FAN GT1200)',
  '24-1743-01E (ASSY DOOR SWITCH W/CABLE LONG GT1200)',
  '24-1744-01E (ASSY DOOR SWITCH W/CABLE SHORT GT1200)',
  '24-1747-01E (ASSY PSU FAN KIT GT1200)',
  '24-1747-01E (POWER SUPPLY FAN)',
  '24-1754-02E (ASSY POWER SWITCH W/CABLE TO ATX&ULTRA)',
  '24-1765-02E (ASSY QUICK PICK DOOR SWITCH LVM W/ CABLE)',
  '24-1766-01E (ASSY SWITCH/LED YEL/GRN PUSH BTN LVM)',
  '24-1766-03E (ASSY SWITCH/LED YEL/GRN PUSH BTN LVM)',
  '24-1783-01E (REAR CONN LINE FILTER 120V LVM)',
  '24-1783-10E (REAR CONN LINE FILTER BASE ASSY)',
  '24-1789-01E',
  '24-1800-01E (LCD ASSEMBLY COMPLETE)',
  '24-1815-01E (ASSY 8.5 LTPIPE CIS W/MTG BRKTS GT1200)',
  '24-1823-01E (ASSY LCD MODULE NLT SINGLE TOUCH GT1200)',
  '24-1900-02E (ASSY BETSLIP HOLDER 48" GEMINI BLACK)',
  '24-1902-01E (ASSY 2D READER GEMINI)',
  '24-1904-02E (ASSY 15 IN ESMM MONITOR NLT DISP GEMINI)',
  '24-1905-02E (ASSY QUICKPICK 6 W/ALARM SILENCE GEMINI)',
  '24-1907-01E (ASSY REAR PANEL GEMINI)',
  '24-1908-01E (ASSY LOCKED STORAGE BOX GEMINI)',
  '24-1909-02E (ASSY JCM DBV 1000 NOTE GEMINI)',
  '24-1913-02E (ASST ADA TICKET BUCKET GEMINI W/LIGHTING)',
  '24-1914-01E (ASSY PLAYER INPUT BUTTONS GEMINI)',
  '24-1915-01E (ASSY DOMESTIC POWER CORD W/BRACKET)',
  '24-1919-01E (ASSY CPU DRAWER GT1200 ATOM E3826)',
  '24-1923-01E (ASSY ADA KEYPAD GEMINI)',
  '24-1928-01E (CIS ASSY FLEX T-1500)',
  '24-1935-05E (ASSY TKT BUCKET 20 BIN W/LIGHT 3" CHUTE)',
  '24-1939-03E (LCD MODULE 16" AUO FLEX T -1500 BLACK)',
  '24-1939-03EU (LCD MODULE 16" AUO FLEX T -1500 BLACK)',
  '24-1943-01EU (RDR ASSY COMPLETE W/TPH FLEX T-1500)',
  '24-1966-01E (ASSY ELECTRONICS TICKETSCAN PLUS TIVA)',
  '24-2006-01E (ASSY CABLE/LED BOARD RIGHT SIDE FLEX)',
  '24-2006-02E (ASSY CABLE/LED BOARD LEFT SIDE FLEX)',
  '24-2011-01E (ASSY 32  INCH DISPLAY)',
  '24-2013-01E (ASSY UPSTACK JCM DBV-400 20 BIN)',
  '24-2014-01E (ASSY 2D READER 4308 20 BIN)',
  '24-2015-01E (ASSY REMOTE COMPONENTS DIPOLE ANTENNA)',
  '24-2016-01E (ASSY HANDLE TOUCH 20 BIN)',
  '24-2019-01E (CABLE KIT CASHLESS G-TOUCH 20)',
  '24-2020-01E (ASSY MAIN POWER SWITCH 20 BIN)',
  '24-2021-01E (ASSY MAIN DOOR SENSOR W/SWITCH 20 BIN)',
  '24-2022-01E (ASSY CPU DOOR 20 BIN SCREWDRIVER LOCK)',
  '24-2066-02E (ASSY,PRINTER,CMPL KISOK,VKP80III,GT20)',
  '24-2068-01E (ASSY 7IN TOUCH DISPLAY COMPLETE)',
  '24-2071-20E (ASSY REAR PANEL CASHLESS USB GT20)',
  '24-2084-01 (ASSY COMPLETE INTERNAL DISPLAY GT20)',
  '24-2085-03-03 (PNTD BZL AND CVR P200 GT20 PAN 185C RED)',
  '24-2086-03E (ASSY INSTALL VERIFONE P200 COVER ONLY)',
  '241532 (CPU CIRCUIT BOARD)',
  '242201 (BOX B-GUIDE A-D4)',
  '242202 (BOX B-GUIDE B-D4)',
  '242995 (MOTOR PINION GEAR)',
  '244004 (OUTSIDE VALIDATION SENSOR BOARD)',
  '244005 (OUTSIDE VALIDATION SENSOR CABLE)',
  '26-0216-01E (LOCK MANUAL WING DRIVE 16MM)',
  '26-0321-01E (HOUSING CAM LATCH E-BOX 28 BIN LVM-3)',
  '26-0322-01E (PHILLIPS LOCK PLUG E-BOX 28 BIN LVM-3)',
  '26-0337-19E (LOCKSET GAMETOUCH 20 WISCONSIN)',
  '26-0338-19E (LOCK MAIN DOOR GAMETOUCH 20 WISCONSIN)',
  '26-0339-19E (LOCK BILL DOOR GAMETOUCH 20 WISCONSIN)',
  '26-310-0002-01E (KEYRING TRI-COLOR)',
  '27-0338-19E (KEY MAIN DOOR GAMETOUCH 20 WISCONSIN)',
  '27-0339-19E (KEY BILL DOOR GAMETOUCH 20 WISCONSIN)',
  '32-0042E (CORD AC 18 AWG 9\'10" 10A@125V)',
  '32-1117-06E (CABLE GT1200 RS485 TO 51-1787-01E LVM)',
  '32-1304-03E (ASSY CABLE ALARM DISABLE LVM 3)',
  '32-1306-02E (ASSY CABLE SPEAKER MONO GAMEPOINT)',
  '32-1318-14E (ASSY CABLE LED BACKLIGHT NLT 15 INCH)',
  '32-1332-02E (ASSY CABLE RF REMOTE GAMEPOINT 433MHZ)',
  '32-1332-04E (ASSY CABLE RF REMOTE 433MHZ GAMETOUCH 20)',
  '32-1347-02E (CABLE GT1200 RS232 TO 51-1787-01E LVM)',
  '32-1370-01E (ASSY CABLE BILL ACCEPTOR GAMEPOINT)',
  '32-1379-01E (ASSY CABLE BURSTER DATA/POWER GAMEPOINT)',
  '32-1379-03E (ASSY CBL BURSTER DATA 5 BIN GAMETOUCH 20)',
  '32-1388-01E (ASSY CABLE USB EXTENSION 60 INCH)',
  '32-1388-06E (ASSY CABLE USB EXTENSION 36 INCH)',
  '32-1388-08E (ASSY CABLE DUAL USB PANEL MOUNT 12 INCH)',
  '32-1403-03E (ASSY CABLE AC TO ATX SUPPLY LVM)',
  '32-1403-04E (ASSY CABLE AC TO ULTRA PRINTER LVM)',
  '32-1406-01 (CABLE FLAT FLEX ACCTHRM SUPREME)',
  '32-1427-01E (ASSY CABLE 4POS LOCKING)',
  '32-1427-02E (ASSY CABLE 6POS 5V PWR)',
  '32-1435-04E (ASSY CABLE 30COND FLATFLEX .5MM 1.5IN)',
  '32-1459-01E (ASSY GFCI POWER CORD 9FT 10IN)',
  '32-1473-01E (ASSY CABLE B/A DATA DBV-300)',
  '32-1509-02E (ASSY CABLE LCD BD-AUO BKL GT1100/1200)',
  '32-1518-01E (CORD AC POWER DOMESTIC 10FT GT1100)',
  '32-1557-04E (ASSY CABLE LCD BD TO NLT 15" LCD GT1200)',
  '32-1558-01E (ASSY CABLE LCD BD TO TOUCH CTLR GT1200)',
  '32-1561-01E (ASSY CABLE SCSI CPU TO LCD/CIS GT1200)',
  '32-1561-01E (ASSY CABLE SCSI CPU TO LCD/CIS GT1200)',
  '32-1562-01E (CABLE GND 70MM CHASSIS HINGE)',
  '32-1565-01E (ASSY CABLE LED SENSOR GT1200)',
  '32-1566-01E (ASSY CABLE TPH/CIS/IF GT1200)',
  '32-1567-01E (ASSY CABLE CIS/IF GT1200)',
  '32-1567-01E (CIS INTERFACE CABLE)',
  '32-1568-01E (ASSY CABLE LED LONG GT1200)',
  '32-1569-01E (ASSY CABLE LED SHORT GT1200)',
  '32-1570-01E (ASSY CABLE CAM SENSOR GT1200)',
  '32-1575-01E (ASSY CABLE FFC 2X6 FOR LVM 7SEG LED MDL)',
  '32-1580-02E (ASSY CABLE HDMI LOCKING 4 FT LVM)',
  '32-1580-04E (ASSY CABLE HDMI LOCKING 8FT)',
  '32-1581-01E (CABLE USB-A TO USB-B JUMPER 1M LG LVM)',
  '32-1582-01E (ASSY CABLE IDC 10POS 2MM LVM)',
  '32-1583-01E (ASSY CABLE QUICKPICK - DATA/PWR LVM)',
  '32-1584-01E (CABLE IDC 2X12 REV TRNSN 2MM LVM)',
  '32-1585-01E (ASSY CABLE INSTANTS - DATA/PWR LVM)',
  '32-1588-07E (ASSY CABLE CUSTOM PTR PWR GT20)',
  '32-1594-01E (ASSY CABLE 6.5IN LVDS LCD - DATA LVM)',
  '32-1598-01E (ASSY CABLE DVI TO ESMM 15IN LCD-DATA LVM)',
  '32-1599-03E (ASSY CABLE W/BEAD 12VDC ESMM AV-6650 LVM)',
  '32-1600-01E (CABLE B/A UBA/DBV DOOR SENSOR LVM)',
  '32-1601-01E (ASSY CABLE MAIN DOOR SENSOR - DATA LVM)',
  '32-1601-06E (ASSY CBL MAIN DR SENSOR W/SWTCH GT 20)',
  '32-1602-01E (ASSY CABLE SPEAKER - DATA LVM)',
  '32-1607-02E (ASSY CABLE POWER SWITCH LVM (ATOM))',
  '32-1607-05E (ASSY CBL PWR SWITCH UL CSA EU GT 20)',
  '32-1609-01E (ASSY CABLE TICKET BIN LIGHTING BD LVM)',
  '32-1609-03E (ASSY CABLE BIN LIGHTING GAMETOUCH 20)',
  '32-1611-01E (ASSY CABLE 6.5IN LCD BACKLITE - PWR LVM)',
  '32-1612-02E (CABLE 1800-01E PWR TO 1785-01E SAMTC LVM)',
  '32-1620-01E (CABLE ETHERNET-BACK PANEL TO GT1200 LVM)',
  '32-1620-04E (ASSY CABLE ETHERNET BEIGE  5FT LVM MINI)',
  '32-1620-05E (ASSY CABLE ETHERNET RED  5FT LVM MINI)',
  '32-1620-06E (ASSY CABLE ETHERNET GREEN  2FT LVM MINI)',
  '32-1621-01E (CABLE 51-1800-01E PWR TO GT1200 BD LVM)',
  '32-1632-02E (ASSY CABLE QUICK PICK DOOR SWITCH LVM)',
  '32-1704-01E (CABLE 1800-02E PWR TO 1868-01E SAMTEC)',
  '32-1705-01E (ASSY CABLE OSD FOR AV-6650 LVM)',
  '32-1706-02E (ASSY CABLE LVDS/DATA NLT 15 INCH LED)',
  '32-1708-04E (CABLE USB DS6707/4208 9FT (2.8M) COILED)',
  '32-1709-02E (ASSY CABLE RS232 M/F EXT LVM L-COM)',
  '32-1710-01E (ASSY CABLE PWR SAFETY GROUND LVM)',
  '32-1711-01E (ASSY CABLE PLAYER INPUT SWITCH LVM)',
  '32-1741-01E (ASSY CABLE GROUND STRAP CPU ENCL LVM)',
  '32-1753-04E (ASSY CABLE ALARM PIEZO 3-7 VDC LVM-3)',
  '32-1756-01E (ASSY CABLE CONTROL BD TO CIS LITEPIPE)',
  '32-1769-01E (ASSY CABLE ADA KEYPAD LVM)',
  '32-1775-01E (ASSY CABLE USB OPTION RIGHT GT1200)',
  '32-1783-03E (ASSY CBL DC POWER 32IN DISPLAY GT 20)',
  '32-1798-01E (CABLE PIT LED PCB SHORT)',
  '32-1799-01E (CABLE PIT LED PCB LONG)',
  '32-1800-01E (CABLE PIT SENSOR PCB LONG)',
  '32-1804-01E (CABLE CIS 2IN1)',
  '32-1805-01E (CABLE CIS HEAD 3IN1)',
  '32-1807-01E (CABLE SCSI TO LCD/CIS)',
  '32-1810-04E (CRD UNV PWR IEC60320-C13-60320-C14 COMPL)',
  '32-1819-01E (ASSY CABLE FLEX PL3307 B110R)',
  '32-1820-01E (ASSY CABLE DC POWER LVM-3)',
  '32-1821-06E (ASSY CBL B/A UPSTACK DBV400 GAMETOUCH 20)',
  '32-1826-01E (CABLE HARNESS FLEXIBLE)',
  '32-1827-01E (CABLE HARNESS W/O GROMMET)',
  '32-1840-02E (ASSY CBL USB A-B RED LABEL 2M LVM-3)',
  '32-1842-02E (ASSY CBL CASHLESS POWER LVM GAMETOUCH 20)',
  '32-1844-01E (CABLE VX820 RS232/ETH DONGLE 3.0M)',
  '32-1944-02E (ASSY CBL USB CUSTOM PRINTER GT20)',
  '32-1952-01E (ASSY CBL USB 2M 7IN DISPLAY GAMETOUCH 28)',
  '32-1953-01E (ASSY CABLE RS232/RS485 TO COMBO BOARD)',
  '32-1954-01E (ASSY CABLE DUAL USB TO COMBO BOARD)',
  '43-1727-02E (IC PROCESSOR CORE 2 DUO T7500 2.2GHZ)',
  '43-1728-02E (IC DDR2 DRAM 1GB GT1200)',
  '43-1910-02E (SataDom 2GB)',
  '43-1910-03E (SATA-3 DOM 4GB)',
  '43-1915-01E (IC SOD DDR3L SDRAM 2GB 1600/1866)',
  '45-0188-01E (DISPLAY TOSHIBA LCD 12.1 GT1100/1200)',
  '45-0194-01E (DISPLAY AUO LCD 12.1 GT1100/1200)',
  '45-0207-01E (DISPLAY LCD 15 INCH LVDS 1024X768 GT1200)',
  '46-1755-03E (PROGRAMMED IC E019 GT1200 BASELINE 2GB)',
  '46-1804-01E (PROGRAMMED IC V1.00 CS:F75C)',
  '46-1933-01E (PROGRAMMED IC V1.0 PID:0X1001 (HEX))',
  '46-2033-02E (PROGRAMMED IC PI27 GEMINI JCM 2GB REV. E)',
  '46-2087-01E (PRGM IC PM03 GT1200 ATOM 2GB SATA3)',
  '46-2133-01E (PROGRAMMED IC Y.2.A.A. V10 TSP TIVA DOM)',
  '46-2146-01E (PROGRAMMED EEPROM V1.0 CS:0DC7)',
  '50-0261-02E (POWER SUPPLY 10W 5V TICKETSCAN PLUS)',
  '50-0290-04E (POWER SUPPLY 300W ATX GP/LVM)',
  '50-0291-01 (POWER SUPPLY 24V ACCTHRM SUPREME)',
  '50-0305-05E (B/A JCM DBV-300 12VDC 1000 US GRN BEZEL)',
  '50-0320-01E (POWER SUPPLY 218W ACED821A GT1200)',
  '50-0320-01E (POWER SUPPLY 218W GT1200)',
  '50-0320-02E (POWER SUPPLY 218W DELTA 1200/1500)',
  '50-0320-02E (USED POWER SUPPLY 218W DELTA 1200/1500)',
  '50-0348-01E (READER ENGINE MOTOROLA SE3300)',
  '50-0359-01E (PWR SPLY 400W ATX W/24VDC (ACBEL REV C4))',
  '50-0361-01E (BILL ACCEPTOR JCM DBV-400 1K GRN BEZEL)',
  '50-0363-01E (DECODER MODULE PL3307 B110R)',
  '50-0379-01E (ASSY LCD 32” DUAL TOUCH SAW USB HDMI)',
  '50-0380-01E (DIPOLE EXT’D RANGE ANTENNA 433.92MHZ)',
  '51-1653-01 (ASSY M280 CNTRLR BD ACCTHM SUPREME)',
  '51-1654-01 (ASSY M280 RS485 INTFC ACCTHRM SUPREME)',
  '51-1654-02 (ASSY M280 RS232 INTFC ACCTHRM SUPREME)',
  '51-1661-01E (BOM QUAD BURSTER EXIT SENSOR BOARD)',
  '51-1717-01E (ASSY INVERTER BOARD GT1100)',
  '51-1764-01E (ASSY CONTROLLER BD GME965 GT1200)',
  '51-1765-01E (ASSY RISER BOARD GT1200)',
  '51-1766-01E (ASSY LCD BOARD GT1200)',
  '51-1780-01E (QUAD BURSTER CONTROLLER BD LVM)',
  '51-1781-01E (INSTANT PRICE DISPLAY CONTROLLER BD LVM)',
  '51-1783-01E (INSTANT PRICE DISPLAY BOARD NUMERIC LVM)',
  '51-1784-03E (ASSY LCD/TOUCH AUO INTERFACE BD LVM)',
  '51-1793-01E (ASSY LED SENSOR BD GT1200)',
  '51-1794-01E (ASSY BOM LED BD GT1200)',
  '51-1794-01E (ASSY LED BD GT1200)',
  '51-1795-01E (ASSY CIS CONTROL BD GT1200)',
  '51-1795-01E (ASSY CIS CONTROL BOARD GT1200)',
  '51-1795-02E (ASSY CIS CONTROL BD W/O BRANDING GT1200)',
  '51-1796-01E (ASSY CIS INTERFACE BD GT1200)',
  '51-1796-01E (ASSY CIS INTERFACE BD GT1200)',
  '51-1800-02E (POWER INTEGRATION BOARD LVM)',
  '51-1807-01E (QUICK PICK 6 LED BOARD LVM)',
  '51-1819-01E (ASSY TOUCH CNTLR SAW USB GT1100/1200)',
  '51-1819-01E (ASSY TOUCH CNTLR SAW USB GT1100/1200)',
  '51-1821-01E (MOTHER BOARD)',
  '51-1821-02E (CONTROLLER BD ATOM N270 GT1200 (640X480))',
  '51-1850-01E (ASSY LCD BOARD AUO GT1200)',
  '51-1850-02E (LCD INTERFACE BOARD)',
  '51-1865-01E (INSTANT PRICE DISPLAY BD 8 LED LVM)',
  '51-1866-01E (ASSY TICKET BIN LIGHTING 4 LED LVM)',
  '51-1866-02E (ASSY TICKET BIN LIGHTING 4 LED LVM)',
  '51-1867-01E (ASSY SCSI BREAKOUT (ATOM) LVM)',
  '51-1868-01E (ASSY SECURITY INTEGRATION (ATOM) LVM)',
  '51-1869-01E (ASSY QUICK PICK 6 CNTRL (ATOM) LVM)',
  '51-1871-01E (ASSY PCI TO USB LVM)',
  '51-1872-02E (LCD CONTROLLER CARD 15 INCH NLT LED)',
  '51-1873-01E (ASSY OSD BOARD FOR AV-6650 LVM)',
  '51-1877-01E (CPU DBV 300)',
  '51-1878-01E (SENSOR BD)',
  '51-1879-01E (MAG SENSOR BD)',
  '51-1880-01E (SMALL P PCB ASSY)',
  '51-1891-01E (BOM CIS LED CONTROL BD W/O BRANDING)',
  '51-1891-03E (BOM CIS LITEPIPE CTRLR BD W/O BRANDING)',
  '51-1896-01E (BOM ADA KEYPAD XFACE)',
  '51-1901-01E (ASSY GT1200 USB OPTION BOARD)',
  '51-1911-01E (BOM CONTROLLER BD E3826 GT1200 ATOM)',
  '51-1911-03E (CONTROLLER BOARD ATOM E384)',
  '51-1911-03EU (BOM CLTR BD ATOM E38451366X68 24 BIT U)',
  '51-1919-01E (BOM PIT INTERFACE BOARD FLEX T-1500)',
  '51-1920-01E (BOM LED BOARD FLEX T-1500)',
  '51-1921-01E (BOM SENSOR BOARD FLEX T-1500)',
  '51-1923-01E (BOM READER CONTROL FLEX T-1500)',
  '51-1923-02E (BOARD,RDR,CNTRL W/O BRND FLEXT-1500)',
  '51-1942-01E (ASSY COMBO BD GEMINI TOUCH28)',
  '51-1991-01E (BOM KABY LAKE DESKTOP - i3-7101TE)',
  '53-0663-01E (TOUCHSCREEN 6.5LCD FIVE WIRE RESISTIVE)',
  '53-0669-01E (IMAGER SCANNER DS6707 PRIVATE LABEL)',
  '53-0671-01E (TOUCH SCREEN)',
  '53-0674-01E (TOUCHSCREEN SAW 15" LCD GT1200)',
  '53-0692-01E (SCANNER DS4308 SNAPI)',
  '53-0697-01E (PRINTER KIOSK VKP80iii)',
  '53-1824-02E (PTR ACCUTHERM ULTRA K MOD 280-03L-K)',
  '55-0098-01E (ANTENNA TERMINAL/RECEPTACLE)',
  '55-0100-01E (ANTENNA REMOTE W/O TERMINAL)',
  '55-174-0009-01E (RF RECEIVER 2 CHANNEL 433 MHz)',
  '55-174-0009-02E (RF REC 2-CHNL 4.33 MHz EXTENDED ANTENNA)',
  '55-174-0010-01E (RF TRANSMTR 2 CHANNEL 433MHZ FIXD CODE A)',
  '61-0784-04E',
  '61-0885-04E',
  '74-1464-01E (CABLE KIT PURCHASED CABINET GT20 KABY)',
  'DBV-400 VALIDATION GUIDE',
  'DBV-400 VALIDATION GUIDE COVER ASSY',
];

export const peripherals = [
  '15-2488-03E',
  '15-4294-02E',
  '24-1595-03E',
  '50-0245-01',
  '50-0245-02E',
  '50-0335-01E',
  '50-0389-13E',
  '52-0660-01E',
  '53-0669-01E',
  '53-0673-01E',
  '53-0673-02E',
  '53-0686-01E',
  '53-0692-01E',
  '53-0694-01E',
  '53-123-0003-01E',
  '61-0376-01',
  '61-0705-01E',
  '61-0766-01E',
  '61-0766-04E',
  '61-0766-06',
  '61-0766-06E',
  '61-0766-08E',
  '61-0766-09E',
  '61-0766-14E',
  '61-0766-18E',
  '61-0766-21E',
  '61-0766-22E',
  '61-0766-24E',
  '61-0901-04E',
  '61-0901-09E',
  '61-0901-11',
  '61-0901-18E',
  '61-0901-19E',
  '61-0901-23E',
  '61-0901-27E',
  '61-0901-28E',
  '61-0901-29E',
  '61-0901-30E',
  '61-0901-31E',
  '61-0901-33E',
  '61-0901-37E',
  '61-0901-38E',
  '61-0901-39E',
  '61-0901-40E',
  '61-0901-41',
  '61-0901-43',
  '61-0901-45',
  '61-2000-02E',
  '61-2000-03E',
  '61-2000-04E',
  '61-2000-06E',
  '61-2000-07E',
  '61-2000-10E',
  '61-2000-12E',
  '61-2000-14E',
  '61-2000-17E',
  '61-2000-22',
  '69-0571-02',
  'NC-444-2000',
  'NC-444-2004',
  'NC-444-2005',
  'NY-444-2005',
];

export const powerSupplyItemNumbers = [
  '50-0170-01',
  '50-0243-02',
  '50-0247-02',
  '50-0247-02E',
  '50-0290-01E',
  '50-0290-04E',
  '50-0359-01E',
  '50-190-0003-01',
  '50-190-0003-01E',
];

export const printers = [
  '12-1970-01E',
  '15-4295-01E',
  '53-0680-11E',
  '53-0680-01E',
  '53-0207-01',
  '53-0215-01',
  '53-0216-01E',
  '53-0216-03E',
  '53-1824-06E',
  '53-1824-02E',
  '53-1824-03E',
  '53-1824-01E',
  '53-0133-22E',
  '53-0133-03E',
  '53-0680-01E',
  '53-0697-01E',
];

export const quadBursterNumberItems = [
  '15-121-0005-10',
  '15-3300-01E',
  '15-3300-02E',
  '15-3300-03E',
  '15-3600-01E',
  '15-3600-02E',
  '15-9006-01',
  '15-9006-04E',
  '32-1379-01E',
];

export const readerItemNumbers = [
  '24-1617-01',
  '24-1707-02E',
  '24-1725-01E',
  '24-1725-02E',
  '24-1725-03E',
  '24-1726-01E',
  '24-1726-03E',
  '24-1726-04E',
  '24-1925-01E',
  '24-1943-01E',
  '24-1943-03E',
  '24-2147-02',
  '53-0126-01E',
  '53-0127-02',
  '53-0127-04',
  '53-0132-01',
  '53-0132-01E',
  '53-0132-02',
  '53-0211-01E',
  '53-0211-02',
  '53-0211-02E',
  '53-0211-03',
  '53-0211-04',
  '53-0225-05E',
  '53-0225-06E',
  '53-0225-07E',
  '53-0228-01',
  '61-0376-01',
  '61-1962-03E',
];

export const solutions = [
  'Calibrate',
  'Clean Components',
  'Replaced Components',
  'ECO',
  'Erase Firmware',
  'Load Firmware',
  'Lube Components',
  'Reflow',
  'Replace Components',
  'Replace Parts',
  'Straighten Chassis',
  'Test Components',
  'Tightening Loose Components',
  'Trace Open',
  'Unrepairable',
  'Update Firmware',
];

export const status = ['PASS', 'FAILED', 'IN PROGRESS', 'NPF', 'SCRAP'];

export const terminals = [
  '15-2488-01E',
  '15-3723-01E',
  '24-1722-12E',
  '24-1723-01E',
  '61-0376-01',
  '61-0413-01',
  '61-0500-01',
  '61-0612-01',
  '61-0670-27E',
  '61-0670-28E',
  '61-0670-31E',
  '61-0670-33E',
  '61-0670-38E',
  '61-0670-39E',
  '61-0670-41E',
  '61-0670-43E',
  '61-0670-44E',
  '61-0670-45',
  '61-0700-01E',
  '61-0705-01E',
  '61-0712-01E',
  '61-0716-01E',
  '61-0739-06E',
  '61-0739-09E',
  '61-0739-11E',
  '61-0739-14E',
  '61-0749-14E',
  '61-0751-01E',
  '61-0752-01E',
  '61-0757-01E',
  '61-0758-01E',
  '61-0762-06E',
  '61-0780-05E',
  '61-0780-07E',
  '61-0780-08E',
  '61-0780-09',
  '61-0780-10E',
  '61-0783-03E',
  '61-0783-07E',
  '61-0783-10E',
  '61-0783-16E',
  '61-0783-18E',
  '61-0784-04E',
  '61-0784-09E',
  '61-0784-12E',
  '61-0784-13E',
  '61-0784-15E',
  '61-0784-17E',
  '61-0784-23',
  '61-0784-24',
  '61-0784-27',
  '61-0784-30',
  '61-0785-04E',
  '61-0785-05E',
  '61-0785-06E',
  '61-0800-37E',
  '61-0883-04E',
  '61-0883-05E',
  '61-0883-07',
  '61-0883-09',
  '61-0883-10',
  '61-0885-06E',
  '61-0885-11',
  '61-0885-18-CM',
  '61-0883-20-CM',
  '61-0900-06E',
  '61-0900-08E',
  '61-0901-40E',
  '61-1961-04E',
  '61-1961-05E',
  '61-1981-02',
  '61-1962-03E',
  '61-1977-06E',
  '61-1988-10',
  '61-2000-17E',
];
